import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/index'

// Containers
const DefaultContainerV2 = () =>
    import ('@/containers/DefaultContainerV2')
const GofixSettingContainer = () =>
    import ('@/containers/GofixSettingContainer');
const TenantsContainer = () =>
    import ('@/containers/TenantsContainer');
const GofixApprovalsContainer = () =>
    import ('@/containers/GofixApprovalsContainer');
const GofixCasesContainer = () =>
    import ('@/containers/GofixCasesContainer');
const GofixPABXContainer = () =>
    import ('@/containers/GofixPABXContainer');
const LMUApprovalForm = () =>
    import ('@/containers/LMUApprovalForm');
//Cases Dasboard
const DashboardCases = () =>
    import ('@/views/DashboardCases');
const CasesOpeningD = () =>
    import ('@/views/dashboard-cases/CaseListing-Opening');
const CasesClosedD = () =>
    import ('@/views/dashboard-cases/CaseListing-Closed');
const CasesAllD = () =>
    import ('@/views/dashboard-cases/CaseListing-All');
const CaseNotification = () =>
    import ('@/views/dashboard-cases/NotificationList');
const NLTEscalationMapping = () =>
    import ('@/views/nlt-escalation/list');
const NLTCoveredSite = () =>
    import ('@/views/nlt-covered-site/list');
const NLTAddressBook = () =>
    import ('@/views/nlt-address-book/list');
const NLTReportList = () =>
    import ('@/views/nlt-report/list');
// Views
const DashboardV2 = () =>
    import ('@/views/DashboardV2');
const ComingSoon = () =>
    import ('@/views/pages/coming-soon');
const DashboardFM = () =>
    import ('@/views/DashboardFM');
const DashboardFMSixMonthlySafetyV2 = () =>
    import ('@/views/DashboardSixMonthlySafetyV2');

// Views - Pages
const Login = () =>
    import ('@/views/pages/Login');
const LoginUni = () =>
    import ('@/views/pages/uni-login');
const Platforms = () =>
    import ('@/views/pages/platforms');
const ForgotPassword = () =>
    import ('@/views/pages/forgot-password');
const ResetPassword = () =>
    import ('@/views/pages/reset-password');
const Microsoft2FA = () =>
    import ('@/views/pages/microsoft-2fa');
const AmazonConnectPABX  = () =>
    import ('@/views/pages/AmazonConnectPABX');

// Users
const UsersListing = () =>
    import ('@/views/users/list');
const UsersDetail = () =>
    import ('@/views/users/detail');
const SupperUser = () =>
    import ('@/views/users/supper-user');
const ProfileUser = () =>
    import ('@/views/users/profile.vue');

// Company
const Companies = () =>
    import ('@/views/usersV2/Companies')
const CompaniesInfo = () =>
    import ('@/views/usersV2/CompaniesInfo')
const ContractFMOfficers = () =>
    import ('@/views/user-duty/list-fm-officer');
const sContractSupplierStaffList = () =>
    import ('@/views/user-duty/list-supplier-staff');
const ClientContractClientStaff = () =>
    import ('@/views/user-duty/list-client-staff');

const ClientContractMaintProgram = () =>
    import ('@/views/contract-maintenance/list')
const MaintProgramMasterV2 = () =>
    import ('@/views/contract-maintenance/list-all')
const MaintProgramInfoV2 = () =>
    import ('@/views/contract-maintenance/detail-info')
const MaintProgramScheduleV2 = () =>
    import ('@/views/contract-maintenance/detail-schedule')
const MaintProgramEquipmentSchedule = () =>
    import ('@/views/contract-maintenance/detail-equipment-schedule')

// Orders
const OrdersALl = () =>
    import ('@/views/orders/list-all');
const OrdersPWO = () =>
    import ('@/views/orders/list-pwo');
const OrdersRWO = () =>
    import ('@/views/orders/list-rwo');
const OrdersCWO = () =>
    import ('@/views/orders/list-cwo');
const OrdersDetail = () =>
    import ('@/views/orders/detail');
const WorkOrder = () =>
    import ('@/views/orders/detail')
const KpiTarget = () =>
    import ('@/views/orders/kpi-target-detail')
const JobListALl = () =>
    import ('@/views/job/all');
const JobListDue = () =>
    import ('@/views/job/due');
const JobListCompleted = () =>
    import ('@/views/job/completed');
const JobListExpired = () =>
    import ('@/views/job/expired');
const ChecklistV2 = () =>
    import ('@/views/job/CheckList')
const JobCalendar = () =>
    import ('@/views/job-calendar/main');

//Roles
const Role = () =>
    import ('@/views/roles/list');

// master setting
const MServiceCategory = () =>
    import ('@/views/mastersetting/ServiceCategory')
const MEquipmentStructure = () =>
    import ('@/views/mastersetting/EquipmentStructure')
const MasterPrioritySet = () =>
    import ('@/views/mastersetting/MasterPrioritySet')
const MasterBrands = () =>
    import ('@/views/mastersetting/MasterBrands')

// Finance
const GeneralLedger = () =>
    import ('@/views/finance/general-ledger/detail');
const GeneralLedgerInfo = () =>
    import ('@/views/finance/general-ledger/detail-info');
const ApInvoices = () =>
    import ('@/views/finance/invoice/list');
const ApInvoicesInfo = () =>
    import ('@/views/finance/invoice/detail');
const PaymentVouchers = () =>
    import ('@/views/finance/payment-voucher/list');
const PaymentVoucherInfo = () =>
    import ('@/views/finance/payment-voucher/detail');
const PostingRules = () =>
    import ('@/views/finance/posting-rules/list');
const NavisionFiles = () =>
    import ('@/views/finance/navision-files/list');
const NavisionFilesConfig = () =>
    import ('@/views/finance/navision-files/navision-setting-config');

// Issue register list
const IssueRegisterList = () =>
    import ('@/views/issueregister/list');
const IssueRegisterDetail = () =>
    import ('@/views/issueregister/IssueRegisterDetail');

//Master GL Account
const MasterGLAccount = () =>
    import ('@/views/masterGLaccount/list');

//Chart Of Account
const ChartOfAccount = () =>
    import ('@/views/chartOfAccount/list');

//Utilities
const Meter = () =>
    import ('@/views/utilities/Meter');
const MeterInfo = () =>
    import ('@/views/utilities/MeterInfo');
const ReadingLog = () =>
    import ('@/views/utilities/ReadingLog');
const ElectricityMeter = () =>
    import ('@/views/utilities/ElectricityMeter');
const ElectricityMeterInfo = () =>
    import ('@/views/utilities/ElectricityMeterInfo');
const ElectricityReadingLog = () =>
    import ('@/views/utilities/ElectricityReadingLog');
const AppVersion = () =>
    import ('@/views/appversion/list');
const TaxVersioning = () =>
    import ('@/views/mastersetting/Tax');
const TaxDetail = () =>
    import ('@/views/mastersetting/TaxDetail');


//Cases Management
const Feedbacks = () =>
    import ('@/views/caseManagement/FeedbackListing');
const FeedbackDetail = () =>
    import ('@/views/caseManagement/FeedbackDetail');
const CasesOpening = () =>
    import ('@/views/caseManagement/CaseListing-Opening');
const CasesClosed = () =>
    import ('@/views/caseManagement/CaseListing-Closed');
const CasesAll = () =>
    import ('@/views/caseManagement/CaseListing-All');

// const OldCases= () => import('@/views/caseManagement/OldCaseListing');
// const OldCaseDetailD = () =>
//     import ('@/views/caseManagement/OldCaseDetail');
    
// const EmailListAll = () =>import('@/views/email-integration/email_all');
const EmailListInbox = () =>import('@/views/email-integration/email_inbox');
const EmailListOutbox = () =>import('@/views/email-integration/email_outbox');
const EmailListAsk = () =>import('@/views/email-integration/email_ask');
const EmailListCstl = () =>import('@/views/email-integration/email_cstl');
const EmailListQp = () =>import('@/views/email-integration/email_qp');

const CaseDetail = () =>
    import ('@/views/caseManagement/CaseDetail');

    
const FilePreview = () =>
import ('@/views/file/main');

//Vendor Linking
const VendorLinking = () =>
    import ('@/views/vendorLinking/VendorLinking');
const VendorLinkingDetail = () =>
    import ('@/views/vendorLinking/VendorLinkingDetail');

//Checklist template
const ContractChecklist = () =>
    import ('@/views/contract-checklist/list');
const ContractChecklistDetail = () =>
    import ('@/views/contract-checklist/detail');
const MasterChecklist = () =>
    import ('@/views/contract-checklist/master');
const MasterChecklistDetail = () =>
    import ('@/views/contract-checklist/detail-master');


//maintenance-standard
const MaintenanceStandard = () =>
    import ('@/views/contract-maintenance/list-standard');
const MaintenanceStandardDetail = () =>
    import ('@/views/contract-maintenance/detail-standard');

//S-contract SOR
const sContractSorList = () =>
    import ('@/views/contract-sor/s-list');
const sContractSorDetail = () =>
    import ('@/views/contract-sor/s-detail');

//S-contract Maintenance
const sContractMaintenanceList = () =>
    import ('@/views/contract-maintenance/s-list');
const sContractMaintenanceDetail = () =>
    import ('@/views/contract-maintenance/s-detail');

//Audit trail
const AuditTrail = () =>
    import ('@/views/audit-trail/list');
const AuditTrailUserInfo = () =>
    import ('@/views/audit-trail/user-info');
const AuditTrailUserActivities = () =>
    import ('@/views/audit-trail/user-activities');

//Import logs
const ImportLogs = () =>
    import ('@/views/import-logs/list');

//Mics Expenses
const MiscExpenses = () =>
    import ('@/views/mics-expenses/list');
const MiscExpensesDetail = () =>
    import ('@/views/mics-expenses/detail');

//const Loader = () => import('@/views/Loader');
const Reference = () =>
    import ('@/views/reference/List');

//Approval Route
const ApprovalTemplate = () =>
    import ('@/views/approval-template/list');
const ContractApproval = () =>
    import ('@/views/contract-approval/list');
const ContractSApproval = () =>
    import ('@/views/contract-approval/s-list');

//User Duty
const UserDuty = () =>
    import ('@/views/user-duty/list');

//Default column Setting
const DefaultColumnSetting = () =>
    import ('@/views/default-column-settings/setting')

//Default column Setting
const FormInputs = () =>
    import ('@/views/elements/forms/list');
const Buttons = () =>
    import ('@/views/elements/buttons/list');
const Tabs = () =>
    import ('@/views/elements/tabs/demo');

//Client contract
const ContractClientListing = () =>
    import ('@/views/contracts/c-list');
const ClientContractInfo = () =>
    import ('@/views/contracts/c-contract-info');


const ClientContractServiceCategory = () =>
    import ('@/views/contract-service-category/c-list');
const ClientContractProperties = () =>
    import ('@/views/contract-properties/c-list');
const ClientContractEmailSettings = () =>
    import ('@/views/contract-email-settings/c-list');
const ClientContractFinace = () =>
    import ('@/views/contract-fmcode/list');
const clientSORList = () =>
    import ('@/views/contract-sor/list');
const clientSORDetail = () =>
    import ('@/views/contract-sor/detail');

//Client contract SLA
const ClientContractSla = () =>
    import ('@/views/contract-sla/c-list');
const ClientContractSlaDetail = () =>
    import ('@/views/contract-sla/c-detail');

// Supplier contract
const ContractSupplierListing = () =>
    import ('@/views/contracts/s-list');
const ScontractInfo = () =>
    import ('@/views/contracts/s-contract-info');
const ScontractServicerCategory = () =>
    import ('@/views/contract-service-category/s-list');
const ScontractProperties = () =>
    import ('@/views/contract-properties/s-list');
const ScontractEquipment = () =>
    import ('@/views/contract-equipment/s-list');
const ScontractFinance = () =>
    import ('@/views/contract-finance/s-finance');


// Views - Equipment (New UI)
const clientContractEquipment = () =>
    import ('@/views/contract-equipment/list');
const clientContractEquipmentDetail = () =>
    import ('@/views/contract-equipment/c-detail');
const clientContractEquipmentGroup = () =>
    import ('@/views/contract-equipment/equipment-group');
const clientContractEquipmentDetailReplaced = () =>
    import ('@/views/contract-equipment/c-detail-replaced');

// Views - Asset Management
const assetManagement = () =>
    import ('@/views/asset-management/list');

// Views - Property Schedule
const propertySchedule = () =>
    import ('@/views/property-schedule/list');

//Tenants
const TenantFeedback = () =>
    import ('@/views/tenants/feedback');
const TenantSiteListing = () =>
    import ('@/views/tenant-sites/list');
const ContactSiteListing = () =>
    import ('@/views/contact-sites/list');

//LMUApprovalForm
const LMUApprovalFormDetail = () =>
    import ('@/views/lmu-approval-form/detail');

//Client contract settings
const ReasonSetting = () =>
    import ("@/views/contract-settings/list");

//Liquidated damages
const LiquidatedDamagesList = () =>
    import ("@/views/finance/liquidated-damages/list");
const LiquidatedDamagesDetail = () =>
    import ("@/views/finance/liquidated-damages/detail");

//Incoming Documents
const IncomingDocuments = () =>
    import ("@/views/lmu-adhoc/incoming-documents/list");
const IncomingDocumentsDetail = () =>
    import ("@/views/lmu-adhoc/incoming-documents/detail");

//Parts replacement
const PartsReplacementHistory = () =>
    import ("@/views/parts-replacement/history");
const PartsReplacementDetail = () =>
    import ("@/views/parts-replacement/detail");
const EquipmentPartsReplacementDetail = () =>
    import ("@/views/contract-equipment/part-replacement-detail");


//Icons
const Icons = () =>
    import ("@/views/icons/SimpleLineIcons");

//UOB
const UOBNotification = () =>
    import ('@/views/uob/notification');
const UOBPayment = () =>
    import ('@/views/uob/payment');
const UOBQRGenerate = () =>
    import ('@/views/uob/qr-generate');
const UOBTransaction = () =>
    import ('@/views/uob/transaction');

//Purging
const Purging = () =>
    import ('@/views/purging/list')

//Mapping Report
const MappingReport = () =>
    import ('@/views/mapping-report/report')

//Mapping Report
const PrivacyPolicy = () =>
    import ('@/views/privacy-policy/index.vue')

// User Management - Password
const PasswordManagement = () =>
    import ('@/views/users/password-management.vue')

//User Audit trail
const AuditTrailRole = () =>
    import ('@/views/audit-trail/audit-trail-role');
const AuditTrailDuty = () =>
    import ('@/views/audit-trail/audit-trail-duty');

//Quick Approval
const DashboardApproval = () =>
    import ('@/views/DashboardApproval');
const QuickWoApproval = () =>
    import ('@/views/orders/list-wo-approval');
const QuickPvApprovalFM = () =>
    import ('@/views/finance/payment-voucher/list-pv-approval-fm');
const QuickPvApprovalLM = () =>
    import ('@/views/finance/payment-voucher/list-pv-approval-lm');
//Budget
const BudgetList = () =>
    import ('@/views/finance/budget/list');
const BudgetDetail = () =>
    import ('@/views/finance/budget/detail');

//Budget Tracking
const BudgetTrackingDetail = () =>
    import ('@/views/finance/budget/detail-tracking');
const BudgetTrackingDetailInfo = () =>
    import ('@/views/finance/budget/detail-tracking-info');

//Contract Setting - Lift Inspection Report
const ContractSettingsLiftInspectionReport = () =>
    import ('@/views/contract-settings-lift-inspection-report/index');

//Job Map
const JobMap = () =>
    import ('@/views/job-map/index');

//Contract Notification
const ContractNotification = () =>
    import ('@/views/contract-notification/index');
const ContractNotificationDetail = () =>
    import ('@/views/contract-notification/detail');
const ContractNotificationMaster = () =>
    import ('@/views/contract-notification/master');
const ContractNotificationDetailMaster = () =>
    import ('@/views/contract-notification/detail-master');
const ContractNotificationEvents = () =>
    import ('@/views/contract-notification/events');
const ContractNotificationParameter = () =>
    import ('@/views/contract-notification/params');

// Contract Case Settings
const ContractCaseSettingsRequesterType = () =>
    import ('@/views/contract-case-settings/index');
const CaseSettingsRequesterTypeMaster = () =>
    import ('@/views/contract-case-settings/requester-type-master');
//Job Map
const OperatingHoursMaster = () =>
    import ('@/views/operating-hours/master');
const OperatingHoursContract = () =>
    import ('@/views/operating-hours/contract');
const MaintenanceSettingsContract = () =>
    import ('@/views/maintenance-settings/contract');
const NavisionCronjob = () =>
    import ('@/views/navision-cronjob/navision-cronjob');
const AppToken = () =>
    import ('@/views/app-token/app-token');
// Setting Case SLA
const CaseSLA = () =>
    import ('@/views/case-sla/index');
// Setting Case SLA
const UserAccessReport = () =>
    import ('@/views/users/access-report');

// Performance Assesment
const PerformanceAssesmentSettings = () =>
    import ('@/views/performance-assesment/settings/index');
const PerformanceAssesmentReport = () =>
    import ('@/views/performance-assesment/report/index');
import ('@/views/performance-assesment/settings/index');
const PAEntryOtherSources = () =>
    import ('@/views/performance-assesment/data-entries/other-sources');
const PAEntryRatesOfDeduction = () =>
    import ('@/views/performance-assesment/data-entries/rates-of-deduction');
const PAEntryPO = () =>
    import ('@/views/performance-assesment/data-entries/po');
const PAEntryMaintenanceRegime = () =>
    import ('@/views/performance-assesment/data-entries/maintenance-regime');

const DashboardSixMonthlySafety = () =>
import ('@/views/DashboardSixMonthlySafety');

const CheckListForDev = () =>
    import ('@/views/job/dev/CheckList')
//LMU Dashboard

const ImportLogsLMU = () =>
    import ('@/views/lmu-adhoc/import-logs/list');

const DashboardLMU = () =>
    import ('@/views/lmu-adhoc/dashboard');
const DefaultContainerLMU = () =>
    import ('@/containers/DefaultContainerLMU');
const LMUNotification = () =>
    import ('@/views/lmu-adhoc/settings/notification');
const LMUNotificationDetail = () =>
    import ("@/views/lmu-adhoc/settings/notification-detail");
const LMUAddressBook = () =>
    import ('@/views/lmu-adhoc/address-book/list');
const LMUBatchSubmissionSummary = () =>
    import ('@/views/lmu-adhoc/batch-submission-summary/list');
const LMUBatchError = () =>
    import ('@/views/lmu-adhoc/batch-submission-summary/batch-error');
const LMUBatchDetail = () =>
    import ('@/views/lmu-adhoc/batch-submission-summary/batch-detail');

//Defect Report
const ApprovalRequestSupplier = () =>
    import ('@/views/lmu-approval-request/supplier/index');
const ApprovalRequestSupplierDetail = () =>
import ('@/views/lmu-approval-request/supplier/detail');
const ApprovalRequestFMOfficer = () =>
    import ('@/views/lmu-approval-request/fm-officer/index');
const ApprovalRequestFMOfficerDetail = () =>
import ('@/views/lmu-approval-request/fm-officer/detail');

// Page 403
const Page403 = () =>
    import ('@/views/pages/Page403');

// Garuda Integration
const GarudaFacilitiesProperties = () =>
    import ('@/views/garuda-integration/facilities-properties/index');
const GarudaInspectionsJobs = () =>
    import ('@/views/garuda-integration/inspections-jobs/index');

const CaseHBDetail = () =>
    import ('@/views/caseHotButton/CaseDetail');


// Views - S-Contract Schedule
const SContractSchedule = () =>
    import ('@/views/s-contract-schedule/list');

//  Offset documents
const OffsetDocuments = () =>
    import ('@/views/finance/offset-documents/list');
const OffsetDocumentDetail = () =>
    import ('@/views/finance/offset-documents/detail');

//  Offset documents
const NLTProperties = () =>
    import ('@/views/nlt-properties/index');

//  Credit Note
const CreditNote = () =>
    import ('@/views/finance/credit-note/list');
const CreditNoteDetail = () =>
    import ('@/views/finance/credit-note/detail');

const LiftInspectionCalendar = () =>
    import ('@/views/lift-inpsection-calendar/index');

const NLTMailingList = () =>
    import ('@/views/nlt-mailing-list/index');


const QuickApprovalCreditNote = () =>
    import ('@/views/finance/credit-note/list-approval');


const QuickApprovalOffsetDocuments = () =>
   import ('@/views/finance/offset-documents/list-approval');

// Safety App
const SafetyInspectionChecklist = () =>
   import ('@/views/safety-app/safety-inspection-checklist/index');

const SafetyInspectionChecklistDetail = () =>
   import ('@/views/safety-app/safety-inspection-checklist/detail');

const SafetyPermitToWork = () =>
   import ('@/views/safety-app/permit-to-work/index');

const SafetyPermitToWorkDetail = () =>
   import ('@/views/safety-app/permit-to-work/detail');

const SafetyNonConformanceReport = () =>
   import ('@/views/safety-app/non-conformance-report/index');

const SafetyNonConformanceReportDetail = () =>
   import ('@/views/safety-app/non-conformance-report/detail');

const SafetyInductionTraining = () =>
   import ('@/views/safety-app/induction-training/index');

const SafetyInductionTrainingDetail = () =>
   import ('@/views/safety-app/induction-training/detail');

const SafetyBriefingRegisterForm = () =>
   import ('@/views/safety-app/induction-training/briefing-register-form');

const SafetyToolboxMeeting = () =>
   import ('@/views/safety-app/toolbox-meeting/index');

const SafetyToolboxMeetingDetail = () =>
   import ('@/views/safety-app/toolbox-meeting/detail');

Vue.use(Router)

const router = new Router({
    mode: 'hash', // https://router.vuejs.org/api/#mode
    linkActiveClass: 'open active',
    scrollBehavior: () => ({ y: 0 }),
    routes: [{
            path: '/uni-login',
            name: 'GOfix FM-Commercial-Uni - Login',
            component: LoginUni,
            meta: {
                title: 'GOfix FM-Commercial - Login',
            }
        },
        {
            path: '/platform',
            name: 'GOfix - Platform',
            component: Platforms,
            meta: {
                title: 'GOfix - Platform',
                requiresAuth: true
            }
        },
        {
            path: '/connect-pabx',
            redirect: '/connect-pabx/',
            meta: {
                requiresAuth: true
            },
            component: GofixPABXContainer,
            children: [
                {
                    path: '',
                    name: 'GOfix - Amazon Connect PABX',
                    meta: { title: 'GOfix - Amazon Connect PABX' },
                    component: AmazonConnectPABX
                },
            ]
        },
        {
            path: '/login',
            name: 'GOfix FM-Commercial - Login',
            component: Login,
            meta: {
                title: 'GOfix FM-Commercial - Login',
                requiresAuth: true,
                metaTags: [{
                    name: 'viewport',
                    content: 'width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=0'
                }, ]
            }
        },
        {
            path: '/reset-password',
            name: 'GOfix FM-Commercial - Forgot Password',
            component: ForgotPassword,
            meta: {
                title: 'GOfix FM-Commercial - Forgot Password',
                requiresAuth: false,
                metaTags: [{
                    name: 'viewport',
                    content: 'width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=0'
                }, ]
            }
        },
        {
            path: '/reset-password/:token',
            name: 'GOfix FM-Commercial - Reset Password',
            component: ResetPassword,
            meta: {
                title: 'GOfix FM-Commercial - Reset Password',
                requiresAuth: false,
                metaTags: [{
                    name: 'viewport',
                    content: 'width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=0'
                }, ]
            }
        },
        {
            path: '/two-factor-authentication',
            name: 'GOfix FM-Commercial - Two-Factor Authentication',
            component: Microsoft2FA,
            meta: {
                title: 'GOfix FM-Commercial - Two-Factor Authentication',
                requiresAuth: true,
                metaTags: [{
                    name: 'viewport',
                    content: 'width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=0'
                }, ]
            }
        },
        {
            path: '/privacy_policies.html',
            name: 'GOfix - Privacy Policy',
            component: PrivacyPolicy,
            meta: {
                title: 'GOfix - Privacy Policies',
                requiresAuth: true,
                metaTags: [{
                    name: 'viewport',
                    content: 'width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=0'
                }]
            }
        },
        {
            path: '/icons',
            name: 'GOfix icons',
            component: Icons,
            meta: {
                title: 'GOfix icons',
                requiresAuth: true,
                metaTags: [{
                    name: 'viewport',
                    content: 'width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=0'
                }, ]
            }
        },
        {
            path: '/',
            // redirect: '/v2/dashboard',
            meta: {
                requiresAuth: true
            },
        },
        {
            path: '/settings',
            redirect: '/settings/companies',
            meta: {
                requiresAuth: true
            },
            component: GofixSettingContainer,
            children: [
                // Accounts Group
                {
                    path: 'companies',
                    redirect: '/settings/companies/',
                    meta: { label: 'Companies', title: 'Companies' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: Companies,
                            meta: {
                                title: 'Companies',
                                roles: {
                                    access: "companies",
                                    action: "read"
                                }
                            },
                        },
                        {
                            path: ':company_id',
                            component: CompaniesInfo,
                            meta: {
                                label: 'FM Company Detail',
                                title: 'FM Company Detail',
                                roles: {
                                    access: "companies",
                                    action: "read"
                                }
                            }
                        },
                        {
                            path: 'supplier/:company_id',
                            component: CompaniesInfo,
                            meta: {
                                label: 'Suppliers Detail',
                                title: 'Suppliers Detail',
                                roles: {
                                    access: "companies",
                                    action: "read"
                                }
                            }
                        },
                        {
                            path: 'client/:company_id',
                            component: CompaniesInfo,
                            meta: {
                                label: 'Client Detail',
                                title: 'Client Detail',
                                roles: {
                                    access: "companies",
                                    action: "read"
                                }
                            }
                        }
                    ]
                },
                {
                    path: 'users',
                    redirect: '/settings/users/',
                    name: 'setting-users',
                    meta: { label: 'Users' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: UsersListing,
                            meta: {
                                title: 'Users',
                                roles: {
                                    access: "users",
                                    action: "read"
                                }
                            },
                        },

                        {
                            path: 'client/add',
                            component: UsersDetail,
                            meta: { label: 'Create User', title: 'Create User' }
                        },
                        {
                            path: 'client/:user_id',
                            meta: {
                                label: 'Edit Users',
                                title: 'User - Info',
                                roles: {
                                    access: "users",
                                    action: "read"
                                }
                            },
                            component: UsersDetail,
                        },

                        {
                            path: 'supplier/add',
                            component: UsersDetail,
                            meta: { label: 'Create User', title: 'Create User' }
                        },
                        {
                            path: 'supplier/:user_id',
                            meta: {
                                label: 'Edit Users',
                                title: 'User - Info',
                                roles: {
                                    access: "users",
                                    action: "read"
                                }
                            },
                            component: UsersDetail,
                        },

                        {
                            path: 'fm-officer/add',
                            component: UsersDetail,
                            meta: { label: 'Create User', title: 'Create User' }
                        },
                        {
                            path: 'fm-officer/:user_id',
                            meta: {
                                label: 'Edit Users',
                                title: 'User - Info',
                                roles: {
                                    access: "users",
                                    action: "read"
                                }
                            },
                            component: UsersDetail,
                        },

                        {
                            path: 'tenant/add',
                            component: UsersDetail,
                            meta: { label: 'Create User', title: 'Create User' }
                        },
                        {
                            path: 'tenant/:user_id',
                            meta: {
                                label: 'Edit Users',
                                title: 'User - Info',
                                roles: {
                                    access: "users",
                                    action: "read"
                                }
                            },
                            component: UsersDetail,
                        },
                    ]
                },
                {
                    path: 'super-user',
                    name: 'setting-super-user',
                    meta: { label: 'Supper Users', title: 'Supper Users' },
                    component: SupperUser
                },
                {
                    path: 'roles',
                    name: 'roles-settings',
                    component: Role,
                    meta: {
                        requiresAuth: true,
                        title: " Roles and Authorisation",
                        label: " Roles and Authorisation",
                        roles: {
                            access: "roles",
                            action: "read"
                        }
                    },
                },
                {
                    path: 'audit-trail',
                    meta: {
                        label: 'Audit trails',
                        title: 'Audit trails',
                        roles: {
                            access: "audit_trail",
                            action: "read"
                        }
                    },
                    component: AuditTrail
                },
                {
                    path: 'audit-trail-user-info',
                    meta: { label: 'Audit Trail - User Info', title: 'Audit Trail - User Info',
                        roles: {
                            access: "allow_can_view_audit_trail_user_info",
                            action: "allow_can_view_audit_trail_user_info"
                        }
                    },
                    component: AuditTrailUserInfo
                },
                {
                    path: 'audit-trail-user-activities',
                    meta: { label: 'Audit Trail - User Activities', title: 'Audit Trail - User Activities',
                        roles: {
                            access: "allow_can_view_audit_trail_user_activities",
                            action: "allow_can_view_audit_trail_user_activities"
                        }
                    },
                    component: AuditTrailUserActivities
                },
                {
                    path: 'audit-trail-role',
                    meta: { label: 'Audit trail - Role Setup', title: 'Audit trail - Role Setup',
                        roles: {
                            access: "allow_can_view_audit_trail_role_setup",
                            action: "allow_can_view_audit_trail_role_setup"
                        }
                    },
                    component: AuditTrailRole

                },
                {
                    path: 'audit-duty-assignment',
                    meta: { label: 'Audit Trail - Duty Assignment', title: 'Audit Trail - Duty Assignment',
                        roles: {
                            access: "allow_can_view_audit_trail_duty_assignment",
                            action: "allow_can_view_audit_trail_duty_assignment"
                        }
                    },
                    component: AuditTrailDuty

                },
                {
                    path: 'import-logs',
                    meta: { 
                        label: 'Import Logs', title: 'Import Logs', 
                        roles: {
                            access: "import_logs",
                            action: "read"
                        }
                    },
                    component: ImportLogs
                },
                {
                    path: 'user-duty',
                    name: 'setting-user-duty',
                    component: UserDuty,
                    meta: {
                        requiresAuth: true,
                        title: "User Duty",
                        label: "User Duty",
                        roles: {
                            access: "user_duty",
                            action: "read"
                        }
                    },
                },
                {
                    path: 'password-management',
                    name: 'password-management',
                    component: PasswordManagement,
                    meta: {
                        requiresAuth: true,
                        title: "Password Management",
                        label: "Password Management",
                        roles: {
                            access: "password_management",
                            action: "read"
                        }
                    },
                },

                //Settings Group
                {
                    path: 'master-service-category',
                    component: MServiceCategory,
                    meta: {
                        label: 'Master Service Category',
                        title: 'Master setting - Service Category',
                        roles: {
                            access: "checklist_template_master",
                            action: "read"
                        }
                    }
                },
                {
                    path: 'master-checklist-template',
                    meta: {
                        label: 'Master Checklist Template',
                        title: 'Master setting - Checklist Template',
                        roles: {
                            access: "checklist_template_master",
                            action: "read"
                        }
                    },
                    redirect: '/v2/master-service-category',
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: MasterChecklist,
                            meta: {
                                title: 'Master setting - Checklist Template',
                                roles: {
                                    access: "checklist_template_master",
                                    action: "read"
                                }
                            },

                        },
                        {
                            path: ':checklist_id',
                            component: MasterChecklistDetail,
                            meta: {
                                label: 'Detail',
                                title: 'Master setting - Checklist Template',
                                roles: {
                                    access: "checklist_template_master",
                                    action: "read"
                                }
                            },
                        }
                    ]
                },
                {
                    path: 'operating-hours',
                    meta: {
                        label: 'Operating Hours',
                        title: 'Operating Hours',
                        roles: {
                            access: "operating_hours",
                            action: "read"
                        }
                    },
                    component: OperatingHoursMaster
                },
                {
                    path: 'navision-cronjob',
                    meta: {
                        label: 'Navision Cronjob Setting',
                        title: 'Navision Cronjob Setting',
                        roles: {
                            access: "navision_cronjob_setting",
                            action: "read"
                        }
                    },
                    component: NavisionCronjob
                },
                {
                    path: 'app-token',
                    meta: {
                        label: 'App Token',
                        title: 'App Token',
                        roles: {
                            access: "app_token",
                            action: "read"
                        }
                    },
                    component: AppToken
                },
                {
                    path: 'maintenance-standard',
                    meta: {
                        label: 'Maintenance Standard',
                        title: 'Master setting - Maintenance Standard',
                        roles: {
                            access: "maintenance_standard",
                            action: "read"
                        }
                    },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: MaintenanceStandard,
                            meta: {
                                label: 'Maintenance Standard',
                                title: 'Master setting - Maintenance Standard',
                                roles: {
                                    access: "maintenance_standard",
                                    action: "read"
                                }
                            },
                        },
                        {
                            path: ':maintenance_id',
                            name: 'setting-maintenance-standard-detail',
                            meta: {
                                label: 'Maintenance Standard Detail',
                                title: 'Detail - Maintenance Standard',
                                roles: {
                                    access: "maintenance_standard",
                                    action: "read"
                                }
                            },
                            component: MaintenanceStandardDetail,
                        }
                    ]
                },
                {
                    path: 'tax-versioning',
                    redirect: '/tax-versioning/',
                    meta: { label: 'Tax And Versioning' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: TaxVersioning,
                            meta: {
                                title: 'Tax And Versioning',
                                roles: {
                                    access: "tax_and_versioning",
                                    action: "read"
                                }
                            },
                        },
                        {
                            path: ':tax_id',
                            meta: {
                                label: 'Tax And Versioning Detail',
                                title: 'Tax And Versioning Detail',
                                roles: {
                                    access: "tax_and_versioning",
                                    action: "read"
                                }
                            },
                            component: TaxDetail,
                        }
                    ]
                },
                {
                    path: 'vendor-linking',
                    redirect: '/vendor-linking/',
                    meta: { label: 'Vendor Linking' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: VendorLinking,
                            meta: {
                                title: 'Vendor Linking',
                                roles: {
                                    access: "vendor_linking",
                                    action: "read"
                                }
                            },
                        },
                        {
                            path: ':id',
                            component: VendorLinkingDetail,
                            meta: {
                                label: 'Vendor Linking Detail',
                                title: 'Vendor Linking Detail',
                                roles: {
                                    access: "vendor_linking",
                                    action: "read"
                                }
                            },
                        },
                    ]
                },
                {
                    path: 'app-version',
                    meta: {
                        label: 'App Version',
                        title: 'App Version',
                        roles: {
                            access: "mobile_app_versioning",
                            action: "read"
                        }
                    },
                    component: AppVersion,
                },
                {
                    path: 'reference-table',
                    component: Reference,
                    meta: { title: 'Reference Table', label: 'Reference Table',
                        roles: {
                            access: "reference_table",
                            action: "read"
                        }
                    }
                },
                {
                    path: 'default-column-settings',
                    component: DefaultColumnSetting,
                    meta: { title: 'Column Setting', label: 'Column Setting',
                        roles: {
                            access: "web_column_setting",
                            action: "read"
                        }
                    }
                },
                {
                    path: 'table-purging',
                    component: Purging,
                    meta: { title: 'Table Purging', label: 'Table Purging',
                        roles: {
                            access: "table_purging",
                            action: "read"
                        }
                    }
                },

                //Mapping Report
                {
                    path: 'mapping-report',
                    name: 'Mapping Report',
                    component: MappingReport,
                    meta: {
                        title: 'Mapping Report',
                        label: 'Mapping Report',
                        roles: {
                            access: "mapping_report",
                            action: "read"
                        }
                    }
                },

                //UOB
                {
                    path: 'uob-notification',
                    name: 'UOB - Notification',
                    component: UOBNotification,
                    meta: {
                        title: 'UOB - Notification',
                        label: 'UOB - Notification',
                        roles: {
                            access: "uob_notifications",
                            action: "read"
                        }
                    }
                },
                {
                    path: 'uob-payment',
                    name: 'UOB - Invoke Payment',
                    component: UOBPayment,
                    meta: {
                        title: 'UOB - Invoke Payment',
                        label: 'UOB - Invoke Payment',
                    }
                },
                {
                    path: 'uob-generate-qr',
                    name: 'UOB - Generate QR code',
                    component: UOBQRGenerate,
                    meta: {
                        title: 'UOB - Generate QR code',
                        label: 'UOB - Generate QR code',
                        roles: {
                            access: "uob_generate_qr",
                            action: "read"
                        }
                    }
                },
                {
                    path: 'uob-transactions',
                    name: 'UOB - Transactions',
                    component: UOBTransaction,
                    meta: {
                        title: 'UOB - Transactions',
                        label: 'UOB - Transactions',
                        roles: {
                            access: "uob_transactions",
                            action: "read"
                        }
                    }
                },
                {
                    path: 'profile',
                    component: ProfileUser,
                    meta: {
                        label: 'User Profile',
                        title: 'User Profile',
                    }
                },
                {
                    path: 'config-notification',
                    redirect: '/settings/config-notification/',
                    meta: { label: 'Notification' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: ContractNotificationMaster,
                            meta: {
                                title: 'Notification',
                                roles: {
                                    access: "master_notification_template",
                                    action: "read"
                                }
                            }
                        },
                        {
                            path: 'event-trigger',
                            component: ContractNotificationEvents,
                            meta: {
                                label: 'Notification - Event Trigger',
                                title: 'Notification - Event Trigger',
                                roles: {
                                    access: "master_notification_event_trigger",
                                    action: "read"
                                }
                            }
                        },
                        {
                            path: 'parameters',
                            component: ContractNotificationParameter,
                            meta: {
                                label: 'Notification - Parameters',
                                title: 'Notification - Parameters',
                                roles: {
                                    access: "master_notification_parameter",
                                    action: "read"
                                }
                            }
                        },
                        {
                            path: ':config_notification_id',
                            component: ContractNotificationDetailMaster,
                            meta: {
                                label: 'Detail',
                                title: 'Notification Detail',
                            }
                        },
                    ]
                },
                {
                    path: 'requestor-types',
                    component: CaseSettingsRequesterTypeMaster,
                    meta: {
                        label: 'Master - Case Requestor Type',
                        title: 'Master - Case Requestor Type',
                        roles: {
                            access: "master_case_requestor_type",
                            action: "read"
                        }
                    }
                },
                {
                    path: 'user-access-report',
                    component: UserAccessReport,
                    meta: {
                        label: 'User Access Report',
                        title: 'User Access Report',
                        roles: {
                            access: "users_access_report",
                            action: "read"
                        }
                    }
                },
                {
                    path: '403-forbidden',
                    component: Page403,
                    meta: {
                        title: '403 Forbidden',
                        requiresAuth: true
                    }
                },
                {
                    path: 'tenant-site',
                    component: TenantSiteListing,
                    meta: {
                        label: 'Tenant sites',
                        title: 'Tenant sites',
                        roles: {
                            access: "tenant_site",
                            action: "read"
                        }
                    }
                },
            ],
        },
        {
            path: '/approvals',
            redirect: '/approvals/',
            meta: {
                requiresAuth: true
            },
            component: GofixApprovalsContainer,
            children: [{
                    path: '/',
                    name: 'quick-approvals',
                    meta: { title: 'Approvals' },
                    component: DashboardApproval
                },
                {
                    path: 'orders',
                    name: 'quick-wo-approvals',
                    redirect: '/approvals/orders/',
                    meta: { label: 'Work Order', title: 'Work Order' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: QuickWoApproval,
                            meta: {
                                title: 'Work Order'
                            },
                        },
                        {
                            path: ':id',
                            component: OrdersDetail,
                            meta: { label: 'Work Order Detail', title: 'Work Order Detail' }
                        }
                    ]
                },
                {
                    path: 'fm-payment-vouchers',
                    name: 'quick-wo-payment-fm',
                    redirect: '/approvals/fm-payment-vouchers/',
                    meta: { label: 'Payment Voucher', title: 'Payment Voucher' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: QuickPvApprovalFM,
                            meta: {
                                title: 'Payment Voucher'
                            },
                        },
                        {
                            path: ':payment_id',
                            component: PaymentVoucherInfo,
                            meta: { label: 'Payment Voucher Detail', title: 'Payment Voucher Detail' }
                        }
                    ]
                },
                {
                    path: 'lm-payment-vouchers',
                    name: 'quick-wo-payment-lm',
                    redirect: '/approvals/lm-payment-vouchers/',
                    meta: { label: 'Payment Voucher', title: 'Payment Voucher' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: QuickPvApprovalLM,
                            meta: {
                                title: 'Payment Voucher'
                            },
                        },
                        {
                            path: ':payment_id',
                            component: PaymentVoucherInfo,
                            meta: { label: 'Payment Voucher Detail', title: 'Payment Voucher Detail' }
                        }
                    ]
                },
                {
                    path: 'profile',
                    component: ProfileUser,
                    meta: {
                        label: 'User Profile',
                        title: 'User Profile',
                    }
                },
                {
                    path: '403-forbidden',
                    component: Page403,
                    meta: {
                        title: '403 Forbidden',
                        requiresAuth: true
                    }
                },
                {
                    path: 'credit-note',
                    name: 'quick-credit-note',
                    redirect: '/approvals/credit-note/',
                    meta: { label: 'Credit Note', title: 'Credit Note' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: QuickApprovalCreditNote,
                            meta: {
                                title: 'Credit Note'
                            },
                        },
                        {
                            path: ':credit_note_id',
                            component: CreditNoteDetail,
                            meta: { label: 'Credit Note Detail', title: 'Credit Note Detail' }
                        }
                    ]
                },
                {
                    path: 'offset-documents',
                    name: 'quick-offset-documents',
                    redirect: '/approvals/offset-documents/',
                    meta: { label: 'Offset Documents', title: 'Offset Documents' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: QuickApprovalOffsetDocuments,
                            meta: {
                                title: 'Offset Documents'
                            },
                        },
                        {
                            path: ':offset_id',
                            component: OffsetDocumentDetail,
                            meta: { label: 'Offset Documents Detail', title: 'Offset Documents Detail' }
                        }
                    ]
                },
            ]
        },
        {
            path: '/case',
            redirect: '/case/',
            meta: {
                requiresAuth: true
            },
            component: GofixCasesContainer,
            children: [{
                    path: 'dashboard',
                    name: 'dashboard',
                    meta: { 
                        title: 'Cases Dashboard',
                        roles: {
                            access: "case_management",
                            action: "read"
                        }
                    },
                    component: DashboardCases
                },
                {
                    path: 'list',
                    component: CasesAllD,
                    name: "case-all-d",
                    meta: {
                        title: 'Case Listing',
                        roles: {
                            access: "case_management",
                            action: "read"
                        }
                    },
                },
                {
                    path: 'list-opening',
                    component: CasesOpeningD,
                    name: "case-opening-d",
                    meta: {
                        title: 'Case Listing',
                        roles: {
                            access: "case_management",
                            action: "read"
                        }
                    },
                },
                {
                    path: 'list-closed',
                    component: CasesClosedD,
                    name: "case-closed-d",
                    meta: {
                        title: 'Case Listing',
                        roles: {
                            access: "case_management",
                            action: "read"
                        }
                    },
                },
                // {
                //     path: 'old-case-list',
                //     redirect:'old-case-list/',
                //     meta: { label: 'Old Case List' },
                //     component: {
                //         render(c) { return c('router-view') }
                //     },
                //     children:[
                //         {
                //             path: '',
                //             name: 'old-case-list-detail',
                //             component: OldCases,
                //             meta: {
                //                 title: 'Old Case Listing',
                //                 roles: {
                //                     access: "old_case_management",
                //                     action: "read"
                //                 }
                //             },
                //         },
                //         {
                //             path: ':id',
                //             name: 'old-case-list-detail-id',
                //             component: OldCaseDetailD,
                //             meta: { label: 'Old Case Detail',
                //                     title: 'Old Case Detail',
                //                     roles: {
                //                         access: "old_case_management",
                //                         action: "read"
                //                     }
                //                }
                //         },
                //     ]
                // },
                {
                    path: 'emails',
                    redirect:'emails/',
                    meta: { label: 'Email Listing' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children:[
                       
                        // {
                        //     path: 'all',
                        //     name: 'emails-listing',
                        //     component: EmailListAll,
                        //     meta: {
                        //         title: 'Emails Listing All',
                        //         // roles: {
                        //         //     access: "old_case_management",
                        //         //     action: "read"
                        //         // }
                        //     },
                        // },
                        // EmailListOutbox
                        {
                            path: 'inbox',
                            name: 'emails-listing-inbox',
                            component: EmailListInbox,
                            meta: {
                                title: 'Emails Listing Inbox',
                                roles: {
                                    access: "email_management",
                                    action: "read"
                                }
                            },
                        },
                        {
                            path: 'outbox',
                            name: 'emails-listing-outbox',
                            component: EmailListOutbox,
                            meta: {
                                title: 'Emails Listing Outbox',
                                roles: {
                                    access: "email_management",
                                    action: "read"
                                }
                            },
                        },
                        {
                            path: 'ask',
                            name: 'emails-listing-ask',
                            component: EmailListAsk,
                            meta: {
                                title: 'Emails Listing Ask',
                                roles: {
                                    access: "email_management",
                                    action: "read"
                                }
                            },
                        },
                        {
                            path: 'cstl',
                            name: 'emails-listing-cstl',
                            component: EmailListCstl,
                            meta: {
                                title: 'Emails Listing Cstl',
                                roles: {
                                    access: "email_management",
                                    action: "read"
                                }
                            },
                        },
                        {
                            path: 'qp',
                            name: 'emails-listing-qp',
                            component: EmailListQp,
                            meta: {
                                title: 'Emails Listing QP',
                                roles: {
                                    access: "email_management",
                                    action: "read"
                                }
                            },
                        },
                        
                    ]
                },
                // {
                //     path: 'case',
                //     redirect: '/case/',
                //     meta: { label: 'Case List' },
                //     component: {
                //         render(c) { return c('router-view') }
                //     },
                //     children: [{
                //             path: '',
                //             component: Cases,
                //             meta: {
                //                 title: 'Case Listing',
                //                 roles: {
                //                     access: "case_management",
                //                     action: "read"
                //                 }
                //             },
                //         },
                //         {
                //             path: ':id',
                //             name: "case-detail",
                //             component: CaseDetail,
                //             meta: {
                //                 label: 'Case Info',
                //                 title: 'Case Info',
                //                 roles: {
                //                     access: "case_management",
                //                     action: "read"
                //                 }
                //             },
                //         },
                //     ]
                // },
                {
                    path: 'approval-template',
                    name: 'approval-template-read',
                    component: ApprovalTemplate,
                    meta: {
                        requiresAuth: true,
                        title: "Approval Template",
                        label: "Approval Template",
                        roles: {
                            access: "approval_template",
                            action: "read"
                        }
                    },
                },
                // {
                //     path: 'old-case-list',
                //     component: OldCases,
                //     meta: {
                //         title: 'Case Listing',
                //         roles: {
                //             access: "case_management",
                //             action: "read"
                //         }
                //     },
                // },
                {
                    path: 'companies',
                    redirect: '/case/companies',
                    meta: { label: 'Companies', title: 'Companies' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: Companies,
                            meta: {
                                title: 'Companies',
                                roles: {
                                    access: "companies",
                                    action: "read"
                                }
                            },
                        },
                        {
                            path: ':company_id',
                            component: CompaniesInfo,
                            meta: { label: 'FM Company Detail', title: 'FM Company Detail' }
                        },
                        {
                            path: 'supplier/:company_id',
                            component: CompaniesInfo,
                            meta: {
                                label: 'Suppliers Detail',
                                title: 'Suppliers Detail',
                                roles: {
                                    access: "companies",
                                    action: "read"
                                }
                            }
                        },
                        {
                            path: 'client/:company_id',
                            component: CompaniesInfo,
                            meta: {
                                label: 'Client Detail',
                                title: 'Client Detail',
                                roles: {
                                    access: "companies",
                                    action: "read"
                                }
                            }
                        }
                    ]
                },
                {
                    path: 'users',
                    redirect: '/case/users/',
                    name: 'setting-usersd',
                    meta: { label: 'Users' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: UsersListing,
                            meta: {
                                title: 'Users',
                                roles: {
                                    access: "users",
                                    action: "read"
                                }
                            },
                        },

                        {
                            path: 'client/add',
                            component: UsersDetail,
                            meta: { label: 'Create User', title: 'Create User' }
                        },
                        {
                            path: 'client/:user_id',
                            meta: {
                                label: 'Edit Users',
                                title: 'User - Info',
                                roles: {
                                    access: "users",
                                    action: "read"
                                }
                            },
                            component: UsersDetail,
                        },

                        {
                            path: 'supplier/add',
                            component: UsersDetail,
                            meta: { label: 'Create User', title: 'Create User' }
                        },
                        {
                            path: 'supplier/:user_id',
                            meta: {
                                label: 'Edit Users',
                                title: 'User - Info',
                                roles: {
                                    access: "users",
                                    action: "read"
                                }
                            },
                            component: UsersDetail,
                        },

                        {
                            path: 'fm-officer/add',
                            component: UsersDetail,
                            meta: { label: 'Create User', title: 'Create User' }
                        },
                        {
                            path: 'fm-officer/:user_id',
                            meta: {
                                label: 'Edit Users',
                                title: 'User - Info',
                                roles: {
                                    access: "users",
                                    action: "read"
                                }
                            },
                            component: UsersDetail,
                        },

                        {
                            path: 'tenant/add',
                            component: UsersDetail,
                            meta: { label: 'Create User', title: 'Create User' }
                        },
                        {
                            path: 'tenant/:user_id',
                            meta: {
                                label: 'Edit Users',
                                title: 'User - Info',
                                roles: {
                                    access: "users",
                                    action: "read"
                                }
                            },
                            component: UsersDetail,
                        },
                    ]
                },
                {
                    path: 'roles',
                    name: 'roles-settingsd',
                    component: Role,
                    meta: {
                        requiresAuth: true,
                        title: " Roles and Authorisation",
                        label: " Roles and Authorisation",
                        roles: {
                            access: "roles",
                            action: "read"
                        }
                    },
                },
                {
                    path: 'audit-trail',
                    meta: { label: 'Audit trails', title: 'Audit trails' },
                    component: AuditTrail
                },
                {
                    path: 'audit-trail-user-info',
                    meta: { 
                        label: 'Audit Trail - User Info', title: 'Audit Trail - User Info',
                        roles: {
                            access: "allow_can_view_audit_trail_user_info",
                            action: "allow_can_view_audit_trail_user_info"
                        }

                    },
                    component: AuditTrailUserInfo
                },
                {
                    path: 'audit-trail-user-activities',
                    meta: { label: 'Audit Trail - User Activities', title: 'Audit Trail - User Activities',
                        roles: {
                            access: "allow_can_view_audit_trail_user_activities",
                            action: "allow_can_view_audit_trail_user_activities"
                        }
                    },
                    component: AuditTrailUserActivities
                },
                {
                    path: 'audit-trail-role',
                    meta: { 
                        label: 'Audit trail - Role Setup', title: 'Audit trail - Role Setup',
                        roles: {
                            access: "allow_can_view_audit_trail_role_setup",
                            action: "allow_can_view_audit_trail_role_setup"
                        }
                    },
                    component: AuditTrailRole

                },
                {
                    path: 'audit-duty-assignment',
                    meta: { 
                        label: 'Audit Trail - Duty Assignment', title: 'Audit Trail - Duty Assignment',
                        roles: {
                            access: "allow_can_view_audit_trail_duty_assignment",
                            action: "allow_can_view_audit_trail_duty_assignment"
                        }

                    },
                    component: AuditTrailDuty

                },
                {
                    path: 'import-logs',
                    meta: { 
                        label: 'Import Logs', title: 'Import Logs',
                        roles: {
                            access: "import_logs",
                            action: "read"
                        }
                    },
                    component: ImportLogs
                },
                {
                    path: 'user-duty',
                    name: 'setting-user-dutyd',
                    component: UserDuty,
                    meta: {
                        requiresAuth: true,
                        title: "User Duty",
                        label: "User Duty",
                    },
                },
                {
                    path: 'config-notification',
                    redirect: '/case/config-notification',
                    meta: { label: 'Notification' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: CaseNotification,
                            meta: {
                                title: 'Notification',
                            }
                        },
                        {
                            path: ':config_notification_id',
                            component: ContractNotificationDetail,
                            meta: {
                                label: 'Detail',
                                title: 'Notification Detail'
                            }
                        }
                    ]
                },
                {
                    path: 'nlt-escalation',
                    meta: {
                        label: 'NLT-Escalation',
                        title: 'NLT-Escalation',
                    },
                    component : NLTEscalationMapping
                },
                {
                    path: 'nlt-covered-site',
                    meta: {
                        label: 'NLT Covered Site',
                        title: 'NLT Covered Site',
                    },
                    component : NLTCoveredSite
                },
                {
                    path: 'profile',
                    component: ProfileUser,
                    meta: {
                        label: 'User Profile',
                        title: 'User Profile',
                    }
                },
                {
                    path: 'sla',
                    name: "case-sla",
                    component: CaseSLA,
                    meta: {
                        label: 'Case SLA',
                        title: 'Case SLA'
                    },
                },
                {
                    path: 'nlt-address-book',
                    meta: {
                        label: 'NLT Address Book',
                        title: 'NLT Address Book',
                    },
                    component : NLTAddressBook
                },
                {
                    path: 'nlt-report-list',
                    meta: {
                        label: 'NLT Report Listing',
                        title: 'NLT Report Listing',
                    },
                    component : NLTReportList
                },
                {
                    path: 'nlt-property',
                    meta: {
                        label: 'NLT Property',
                        title: 'NLT Property',
                        roles: {
                            access: "nlt_property",
                            action: "read"
                        }
                    },
                    component : NLTProperties
                },
                {
                    path: '403-forbidden',
                    component: Page403,
                    meta: {
                        title: '403 Forbidden',
                        requiresAuth: true
                    }
                },
                {
                    path: 'nlt-mailing-list-management',
                    meta: {
                        label: 'NLT Mailing List Management',
                        title: 'NLT Mailing List Management',
                    },
                    component : NLTMailingList
                },
                {
                    path: ':id',
                    name: "case-detail",
                    component: CaseDetail,
                    meta: {
                        label: 'Case Info',
                        title: 'Case Info',
                        roles: {
                            access: "case_management",
                            action: "read"
                        }
                    },
                },
                {
                    path: ':id/:email_id',
                    name: "case-detail-email",
                    component: CaseDetail,
                    meta: {
                        label: 'Case Info',
                        title: 'Case Info',
                        roles: {
                            access: "case_management",
                            action: "read"
                        }
                    },
                },
            ]
        },
        {
            path: '/v2',
            redirect: '/v2/dashboard',
            meta: {
                requiresAuth: true,
                metaTags: [{
                    name: 'viewport',
                    content: 'width=1366,initial-scale=1'
                }, ]
            },
            component: DefaultContainerV2,
            children: [{
                    path: 'coming-soon',
                    component: ComingSoon,
                    meta: { title: 'Coming Soon' }
                },
                {
                    path: 'dashboard',
                    component: DashboardV2,
                    meta: { title: 'Dashboard' }
                },
                {
                    path: 'fm-dashboard',
                    component: DashboardFM,
                    meta: { title: 'FM Dashboard' }
                },
                {
                    path: 'fm-dashboard-six-monthly-safety-hazard-inspection',
                    component: DashboardFMSixMonthlySafetyV2,
                    meta: { title: 'FM Dashboard' }
                },
                {
                    path: 'dashboard-six-monthly-safety-hazard-inspection',
                    component: DashboardSixMonthlySafety,
                    meta: { title: 'Dashboard Six Monthly Safety Hazard Inspection' }
                },
                {
                    path: 'contract-client',
                    redirect: '/v2/contract-client/',
                    meta: { label: 'Client Contract List' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: ContractClientListing,
                            meta: {
                                title: 'Client Contract List',
                                roles: {
                                    access: "client_contract_listing",
                                    action: "read"
                                }
                            }
                        },
                        {
                            path: ':id',
                            redirect: '/v2/contract-client/:id/',
                            meta: { /*label: 'Contract'*/ },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [{
                                    path: '',
                                    component: ClientContractInfo,
                                    meta: {
                                        label: 'Contract ',
                                        title: 'Contract Info',
                                        roles: {
                                            access: "contractinfo",
                                            action: "read"
                                        }
                                    }
                                },

                                {
                                    path: 'service-category',
                                    component: ClientContractServiceCategory,
                                    meta: {
                                        label: 'Contract',
                                        title: 'Service Category',
                                        roles: {
                                            access: "service_category",
                                            action: "read"
                                        }
                                    }
                                },
                                {
                                    path: 'sla',
                                    redirect: '/contract-client/:id/sla/',
                                    meta: { label: 'Contract' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [{
                                            path: '',
                                            component: ClientContractSla,
                                            meta: {
                                                title: 'SLA',
                                                roles: {
                                                    access: "sla",
                                                    action: "read"
                                                }
                                            },
                                        },
                                        {
                                            path: 'add',
                                            component: ClientContractSlaDetail,
                                            meta: {
                                                label: 'SLA',
                                                title: 'SLA',
                                                roles: {
                                                    access: "sla",
                                                    action: "read"
                                                }
                                            },
                                        },
                                        {
                                            path: ':sla_id',
                                            component: ClientContractSlaDetail,
                                            meta: {
                                                label: 'SLA',
                                                title: 'SLA',
                                                roles: {
                                                    access: "sla",
                                                    action: "read"
                                                }
                                            },
                                        }
                                    ]
                                },
                                {
                                    path: 'properties',
                                    name: 'Properties',
                                    component: ClientContractProperties,
                                    meta: {
                                        label: 'Contract',
                                        title: 'Properties',
                                        roles: {
                                            access: "properties",
                                            action: "read"
                                        }
                                    }
                                },
                                {
                                    path: 'email-settings',
                                    name: 'EmailSettings',
                                    component: ClientContractEmailSettings,
                                    meta: {
                                        label: 'Contract',
                                        title: 'EmailSettings',
                                        roles: {
                                            access: "properties",
                                            action: "read"
                                        }
                                    }
                                },
                                {
                                    path: 'equipment',
                                    redirect: '/contract-client/:id/equipment/',
                                    meta: { label: 'Contract' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [{
                                            path: '',
                                            component: clientContractEquipment,
                                            meta: {
                                                title: 'Equipment',
                                                roles: {
                                                    access: "equipment",
                                                    action: "read"
                                                }
                                            }
                                        },
                                        {
                                            path: 'equipment-structure',
                                            component: clientContractEquipmentGroup,
                                            meta: {
                                                label: 'Equipment Structure',
                                                title: 'Equipment Structure',
                                                roles: {
                                                    access: "equipment",
                                                    action: "read"
                                                }
                                            }
                                        },
                                        {
                                            path: 'add',
                                            component: clientContractEquipmentDetail,
                                            meta: {
                                                label: 'Equipment Detail',
                                                title: 'Equipment Detail',
                                                roles: {
                                                    access: "equipment",
                                                    action: "read"
                                                }
                                            }
                                        },

                                        {
                                            path: ':equipment_id',
                                            redirect: '/contract-client/:id/equipment/:equipment_id/',
                                            name: 'equipment-detail',
                                            meta: { label: 'Equipment Detail' },
                                            component: {
                                                render(c) { return c('router-view') }
                                            },
                                            children: [{
                                                    path: '',
                                                    component: clientContractEquipmentDetail,
                                                    meta: {
                                                        title: 'Equipment Detail',
                                                        roles: {
                                                            access: "equipment",
                                                            action: "read"
                                                        }
                                                    }
                                                },
                                                {
                                                    path: 'part-replacement/:part_replacement_id',
                                                    component: EquipmentPartsReplacementDetail,
                                                    meta: {
                                                        label: 'Parts Replacement Detail',
                                                        title: 'Parts Replacement Detail'
                                                    }
                                                },
                                                {
                                                    path: 'replaced',
                                                    component: clientContractEquipmentDetailReplaced,
                                                    meta: {
                                                        label: 'Replaced',
                                                        title: 'Replaced Equipment'
                                                    }
                                                },
                                            ]
                                        },
                                    ]
                                },
                                {
                                    path: 'sor',
                                    redirect: '/contract-client/:id/sor/',
                                    name: 'Sor',
                                    meta: { label: 'Contract' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [{
                                            path: '',
                                            component: clientSORList,
                                            meta: {
                                                title: 'Sor',
                                                roles: {
                                                    access: "sor",
                                                    action: "read"
                                                }
                                            }
                                        },
                                        {
                                            name: "edit-sor",
                                            path: ':sor_id',
                                            component: clientSORDetail,
                                            meta: {
                                                label: 'SOR',
                                                title: 'SOR',
                                                roles: {
                                                    access: "sor",
                                                    action: "read"
                                                }
                                            }
                                        }
                                    ]
                                },
                                {
                                    path: 'maintenance-program',
                                    redirect: '/contract-client/:id/maintenance-program/',
                                    meta: { label: 'Contract' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [{
                                            path: '',
                                            component: ClientContractMaintProgram,
                                            meta: {
                                                title: 'Maintenance Program',
                                                roles: {
                                                    access: "client_contract_program",
                                                    action: "read"
                                                }
                                            }
                                        },
                                        {
                                            path: 'add',
                                            component: MaintProgramInfoV2,
                                            meta: { label: 'Maint. Program', title: 'Maintenance Program' }
                                        },
                                        {
                                            path: ':maintenance_id',
                                            redirect: '/maintenance-program/:maintenance_id/',
                                            component: {
                                                render(c) { return c('router-view') }
                                            },
                                            children: [{
                                                    path: '',
                                                    component: MaintProgramInfoV2,
                                                    meta: {
                                                        label: 'Maint. Program',
                                                        title: 'Maintenance Program - Info',
                                                        roles: {
                                                            access: "client_contract_program",
                                                            action: "read"
                                                        }
                                                    }
                                                },
                                                {
                                                    path: 'schedule',
                                                    component: MaintProgramScheduleV2,
                                                    meta: {
                                                        label: 'Maint. Program',
                                                        title: 'Maintenance Program - Schedule',
                                                        roles: {
                                                            access: "client_contract_program",
                                                            action: "read"
                                                        }
                                                    }
                                                },
                                                {
                                                    path: 'equipment-schedule',
                                                    component: MaintProgramEquipmentSchedule,
                                                    meta: {
                                                        label: 'Equipment Schedule',
                                                        title: 'Maintenance Program - Equipment Schedule',
                                                        roles: {
                                                            access: "maintenance_program",
                                                            action: "read"
                                                        }
                                                    }
                                                }
                                            ]
                                        },
                                    ]
                                },
                                {
                                    path: 'fm-officers',
                                    redirect: '/contract-client/:id/fm-officers/',
                                    meta: { label: 'Contract' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [{
                                            path: '',
                                            component: ContractFMOfficers,
                                            meta: {
                                                title: 'FM officers',
                                                roles: {
                                                    access: "fm_officer",
                                                    action: "read"
                                                }
                                            },
                                        },
                                        /*{
                                          path: 'add',
                                          component: FMOfficersInfo,
                                          meta: {
                                            label: 'Users Detail', title: 'Users Detail', roles: {
                                              access: "fm_officer",
                                              action: "read"
                                            }
                                          },
                                        },
                                        {
                                          path: ':fmofficer_id',
                                          component: FMOfficersInfo,
                                          meta: {
                                            label: 'Users Detail', title: 'Users Detail', roles: {
                                              access: "fm_officer",
                                              action: "read"
                                            }
                                          }
                                        }*/
                                    ]
                                },
                                {
                                    path: 'client-staff',
                                    redirect: '/contract-client/:id/client-staff/',
                                    meta: { label: 'Contract' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [{
                                            path: '',
                                            component: ClientContractClientStaff,
                                            meta: { title: 'Client Staff' },
                                        },
                                        // {
                                        //   path: 'add',
                                        //   component: ClientStaffInfoV2,
                                        //   meta: { label: 'Client Staff', title: 'Create Client Staff' },
                                        // },
                                        // {
                                        //   path: ':client_id',
                                        //   component: ClientStaffInfoV2,
                                        //   meta: { label: 'Client Staff', title: 'Client Staff Info' }
                                        // }
                                    ]
                                },
                                {
                                    path: 'checkList-template',
                                    redirect: '/contract-client/:id/checkList-template-v2/',
                                    meta: { label: 'Contract' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [{
                                            path: '',
                                            component: ContractChecklist,
                                            meta: {
                                                title: 'Checklist Template',
                                                roles: {
                                                    access: "checklist_template",
                                                    action: "read"
                                                }
                                            }
                                        },
                                        {
                                            path: 'add',
                                            component: ContractChecklistDetail,
                                            meta: {
                                                label: 'Checklist Temp.',
                                                title: 'Checklist Temp.',
                                                roles: {
                                                    access: "checklist_template",
                                                    action: "read"
                                                }
                                            }
                                        },
                                        {
                                            path: ':checklist_template_id',
                                            component: ContractChecklistDetail,
                                            meta: {
                                                label: 'Checklist Temp.',
                                                title: 'Checklist Temp.',
                                                roles: {
                                                    access: "checklist_template",
                                                    action: "read"
                                                }
                                            }
                                        }
                                    ]
                                },
                                {
                                    path: 'approval',
                                    component: ContractApproval,
                                    meta: {
                                        label: 'Contract',
                                        title: 'Approval Route',
                                        roles: {
                                            access: "approval",
                                            action: "read"
                                        }
                                    },
                                },
                                {
                                    path: 'fm-codes',
                                    component: ClientContractFinace,
                                    meta: { label: 'Contract', title: 'Finance' },
                                },
                                {
                                    path: 'settings',
                                    component: ReasonSetting,
                                    meta: { label: 'Contract', title: 'Settings' },
                                },
                                {
                                    path: 'report-config',
                                    component: ContractSettingsLiftInspectionReport,
                                    meta: { label: 'Report Config', title: 'Report Config' },
                                },
                                {
                                    path: 'config-notification',
                                    redirect: '/contract-client/:id/config-notification/',
                                    meta: { label: 'Notification' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [{
                                            path: '',
                                            component: ContractNotification,
                                            meta: {
                                                title: 'Notification',
                                            }
                                        },
                                        {
                                            path: ':config_notification_id',
                                            component: ContractNotificationDetail,
                                            meta: {
                                                label: 'Detail',
                                                title: 'Notification Detail'
                                            }
                                        }
                                    ]
                                },
                                {
                                    path: 'case-settings',
                                    component: ContractCaseSettingsRequesterType,
                                    meta: { label: 'Case Settings', title: 'Case Settings' },
                                },
                                {
                                    path: 'operating-hours',
                                    component: OperatingHoursContract,
                                    meta: { label: 'Operating Hours', title: 'Operating Hours' },
                                },
                                {
                                    path: 'maintenance-settings',
                                    component: MaintenanceSettingsContract,
                                    meta: { label: 'Maintenance Settings', title: 'Maintenance Settings' },
                                },
                                //
                            ]
                        }
                    ]
                },
                {
                    path: 'contract-supplier',
                    redirect: '/v2/contract-supplier/',
                    meta: { label: 'Supplier Contract List' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: ContractSupplierListing,
                            meta: {
                                title: 'Supplier Contract List',
                                roles: {
                                    access: "supplier_contract_listing",
                                    action: "read"
                                }
                            }
                        },
                        {
                            path: ':id',
                            redirect: '/contract-supplier/:id/',
                            meta: { /*label: 'Contract'*/ },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [{
                                    path: '',
                                    component: ScontractInfo,
                                    meta: {
                                        label: 'Supplier Contract',
                                        title: 'Contract Info',
                                        roles: {
                                            access: "supplier_contract_info",
                                            action: "read"
                                        }
                                    }
                                },
                                {
                                    path: 'service-category',
                                    component: ScontractServicerCategory,
                                    meta: {
                                        label: 'Supplier Contract',
                                        title: 'Service Category',
                                        roles: {
                                            access: "supplier_contract_service_category",
                                            action: "read"
                                        }
                                    }
                                },
                                {
                                    path: 'properties',
                                    name: 'Properties supplier',
                                    component: ScontractProperties,
                                    meta: {
                                        label: 'Supplier Contract',
                                        title: 'Properties',
                                        roles: {
                                            access: "supplier_contract_property",
                                            action: "read"
                                        }
                                    }
                                },
                                {
                                    path: 'equipment',
                                    component: ScontractEquipment,
                                    meta: {
                                        label: 'Supplier Contract',
                                        title: 'Equipment',
                                        roles: {
                                            access: "supplier_contract_equipment",
                                            action: "read"
                                        }
                                    }
                                },
                                {
                                    path: 'sor',
                                    redirect: '/contract-supplier/:id/sor/',
                                    meta: { label: 'Supplier Contract' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [{
                                            path: '',
                                            component: sContractSorList,
                                            meta: { /*label: 'SOR',*/
                                                title: 'SOR',
                                                roles: {
                                                    access: "supplier_contract_sor",
                                                    action: "read"
                                                }
                                            }
                                        },
                                        {
                                            path: ':sor_id',
                                            name: "s-edit-sor",
                                            component: sContractSorDetail,
                                            meta: {
                                                label: 'SOR',
                                                title: 'SOR',
                                                roles: {
                                                    access: "supplier_contract_sor",
                                                    action: "read"
                                                }
                                            }
                                        }
                                    ]
                                },
                                {
                                    path: 'maintenance-program',
                                    redirect: '/contract-supplier/:id/maintenance-program/',
                                    meta: { label: 'Supplier Contract' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [{
                                            path: '',
                                            component: sContractMaintenanceList,
                                            meta: { /*label: 'SOR',*/
                                                title: 'Maintenance Program',
                                                roles: {
                                                    access: "supplier_contract_program",
                                                    action: "read"
                                                }
                                            }
                                        },
                                        {
                                            path: ':maintenance_id',
                                            component: sContractMaintenanceDetail,
                                            name: "s-edit-maintenance",
                                            meta: {
                                                label: 'Maintenance Program Detail',
                                                title: 'Maintenance Program Detail',
                                                roles: {
                                                    access: "supplier_contract_program",
                                                    action: "read"
                                                }
                                            }
                                        }
                                    ]
                                },
                                /*{
                                  path: 'fm-staff',
                                  name: 'list-fm-user',
                                  component: sContractFMStaffList,
                                  meta: { label: 'Supplier Contract', title: 'FM Officers' }
                                },*/
                                {
                                    path: 'supplier-staff',
                                    redirect: '/contract-supplier/:id/supplier-staff/',
                                    meta: { label: 'Supplier Contract' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [{
                                        path: '',
                                        name: 'list-supplier-staff',
                                        component: sContractSupplierStaffList,
                                        meta: {
                                            title: 'Supplier Staff',
                                            roles: {
                                                access: "supplier_contract_staff",
                                                action: "read"
                                            }
                                        }
                                    }]
                                },
                                {
                                    path: 'finance',
                                    component: ScontractFinance,
                                    meta: {
                                        label: 'Finance',
                                        title: 'Finance',
                                        // roles: {
                                        //     access: "supplier_contract_equipment",
                                        //     action: "read"
                                        // }
                                    }
                                },
                                {
                                    path: 'approval',
                                    component: ContractSApproval,
                                    meta: {
                                        label: 'Contract',
                                        title: 'Approval Route',
                                        // roles: {
                                        //     access: "approval",
                                        //     action: "read"
                                        // }
                                    },
                                },
                            ]
                        },
                    ]
                },
                {
                    path: 'users',
                    redirect: '/v2/users/',
                    name: 'Users',
                    meta: { label: 'Users' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: UsersListing,
                            meta: {
                                title: 'Users',
                                roles: {
                                    access: "users",
                                    action: "read"
                                }
                            },
                        },

                        {
                            path: 'client/add',
                            component: UsersDetail,
                            meta: { label: 'Create User', title: 'Create User' }
                        },
                        {
                            path: 'client/:user_id',
                            meta: {
                                label: 'Edit Users',
                                title: 'User - Info',
                                roles: {
                                    access: "users",
                                    action: "read"
                                }
                            },
                            component: UsersDetail,
                        },

                        {
                            path: 'supplier/add',
                            component: UsersDetail,
                            meta: { label: 'Create User', title: 'Create User' }
                        },
                        {
                            path: 'supplier/:user_id',
                            meta: {
                                label: 'Edit Users',
                                title: 'User - Info',
                                roles: {
                                    access: "users",
                                    action: "read"
                                }
                            },
                            component: UsersDetail,
                        },

                        {
                            path: 'fm-officer/add',
                            component: UsersDetail,
                            meta: { label: 'Create User', title: 'Create User' }
                        },
                        {
                            path: 'fm-officer/:user_id',
                            meta: {
                                label: 'Edit Users',
                                title: 'User - Info',
                                roles: {
                                    access: "users",
                                    action: "read"
                                }
                            },
                            component: UsersDetail,
                        },

                        {
                            path: 'tenant/add',
                            component: UsersDetail,
                            meta: { label: 'Create User', title: 'Create User' }
                        },
                        {
                            path: 'tenant/:user_id',
                            meta: {
                                label: 'Edit Users',
                                title: 'User - Info',
                                roles: {
                                    access: "users",
                                    action: "read"
                                }
                            },
                            component: UsersDetail,
                        },

                    ]
                },
                {
                    path: 'super-user',
                    name: 'super-user',
                    meta: { label: 'Supper Users', title: 'Supper Users' },
                    component: SupperUser
                },
                {
                    path: 'roles',
                    name: 'roles',
                    component: Role,
                    meta: {
                        requiresAuth: true,
                        title: " Roles and Authorisation",
                        label: " Roles and Authorisation",
                        roles: {
                            access: "roles",
                            action: "read"
                        }
                    },
                },
                {
                    path: 'audit-trail',
                    meta: {
                        roles: {
                            access: "audit_trail",
                            action: "read"
                        },
                        label: 'Audit trails',
                        title: 'Audit trails'
                    },
                    component: AuditTrail
                },
                {
                    path: 'import-logs',
                    meta: {
                        label: 'Import Logs',
                        title: 'Import Logs',
                        roles: {
                            access: "import_logs",
                            action: "read"
                        }
                    },
                    component: ImportLogs
                },
                {
                    path: 'companies',
                    redirect: '/v2/companies/',
                    meta: { label: 'Companies', title: 'Companies' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: Companies,
                            meta: {
                                title: 'Companies',
                                roles: {
                                    access: "companies",
                                    action: "read"
                                }
                            },
                        },
                        {
                            path: ':company_id',
                            component: CompaniesInfo,
                            meta: { label: 'FM Company Detail', title: 'FM Company Detail' }
                        },
                        {
                            path: 'supplier/:company_id',
                            component: CompaniesInfo,
                            meta: {
                                label: 'Suppliers Detail',
                                title: 'Suppliers Detail',
                                roles: {
                                    access: "companies",
                                    action: "read"
                                }
                            }
                        },
                        {
                            path: 'client/:company_id',
                            component: CompaniesInfo,
                            meta: {
                                label: 'Client Detail',
                                title: 'Client Detail',
                                roles: {
                                    access: "companies",
                                    action: "read"
                                }
                            }
                        }
                    ]
                },
                {
                    path: 'files',
                    redirect: '/v2/files/',
                    meta: { label: 'Files', title: 'Files' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: FilePreview,
                            meta: {
                                title: 'Files',
                                roles: {
                                    access: "companies",
                                    action: "read"
                                }
                            },
                        },
                        {
                            path: ':file_id',
                            name: 'FilePreview',
                            component: FilePreview,
                            meta: { label: 'File Preview', title: 'File Preview' }
                        }
                    ]
                },
                {
                    path: 'orders',
                    redirect: '/v2/orders/',
                    component: {
                        render(c) { return c('router-view') }
                    },
                    meta: {
                        label: 'Work Order',
                        requiresAuth: true
                    },
                    children: [{
                            path: '',
                            component: OrdersALl,
                            name: "orders-all",
                            meta: {
                                title: 'Work Order',
                                type: "list",
                                roles: {
                                    access: "order",
                                    action: "read"
                                }
                            }
                        },
                        {
                            path: 'preventive',
                            component: OrdersPWO,
                            name: "orders-preventive",
                            meta: {
                                label: 'Preventive WO',
                                title: 'Preventive WO',
                                type: "list",
                                roles: {
                                    access: "order",
                                    action: "read"
                                }
                            }
                        },
                        {
                            path: 'corrective',
                            component: OrdersCWO,
                            name: "orders-corrective",
                            meta: {
                                label: 'Corrective WO',
                                title: 'Corrective WO',
                                type: "list",
                                roles: {
                                    access: "order",
                                    action: "read"
                                }
                            }
                        },
                        {
                            path: 'reactive',
                            component: OrdersRWO,
                            name: "orders-reactive",
                            meta: {
                                label: 'Reactive WO',
                                title: 'Reactive WO',
                                type: "list",
                                roles: {
                                    access: "order",
                                    action: "read"
                                }
                            }
                        },
                        {
                            path: ':id',
                            redirect: '/orders/:id/',
                            meta: { label: 'Program', type: 'breadcrumbs' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [{
                                    path: '',
                                    component: WorkOrder,
                                    name: "work-order-info",
                                    meta: {
                                        title: 'Order - Info',
                                        type: "list",
                                        roles: {
                                            access: "order",
                                            action: "read"
                                        }
                                    }
                                },
                                {
                                    path: 'tmp',
                                    component: OrdersDetail,
                                    meta: {
                                        title: 'Order - Info',
                                        type: "list",
                                        roles: {
                                            access: "order",
                                            action: "read"
                                        }
                                    }
                                },
                                {
                                    path: 'kpi-target',
                                    component: WorkOrder,
                                    meta: {
                                        title: 'Order - KPI Target',
                                        type: "list",
                                        roles: {
                                            access: "order",
                                            action: "read"
                                        }
                                    }
                                },
                                {
                                    path: 'kpi-target/:kpi_target_id',
                                    component: KpiTarget,
                                    meta: { title: 'Edit KPI Target' }
                                },
                                {
                                    path: 'service-report',
                                    component: WorkOrder,
                                    meta: {
                                        title: 'Order - Service Report',
                                        type: "list",
                                        roles: {
                                            access: "order",
                                            action: "read"
                                        }
                                    }
                                },
                                {
                                    path: 'related-work-items',
                                    component: WorkOrder,
                                    meta: {
                                        title: 'Order - Related Work Items',
                                        type: "list",
                                        roles: {
                                            access: "order",
                                            action: "read"
                                        }
                                    }
                                },
                                {
                                    path: 'budget',
                                    component: WorkOrder,
                                    meta: {
                                        title: 'Order - Budget',
                                        type: "list",
                                        roles: {
                                            access: "order",
                                            action: "read"
                                        }
                                    }
                                },
                                {
                                    path: 'activity-log',
                                    component: WorkOrder,
                                    meta: {
                                        title: 'Order - Activity Log',
                                        type: "list",
                                        roles: {
                                            access: "order",
                                            action: "read"
                                        }
                                    }
                                },
                            ]
                        }
                    ]
                },
                {
                    path: 'job-list',
                    redirect: '/v2/job-list/',
                    meta: { label: 'Job List' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            name: 'job-list-all',
                            component: JobListALl,
                            meta: {
                                title: 'Job List',
                                roles: {
                                    access: "job_list",
                                    action: "read"
                                }
                            }
                        },
                        {
                            path: 'due',
                            name: 'job-list-due',
                            component: JobListDue,
                            meta: {
                                title: 'Job List',
                                roles: {
                                    access: "job_list",
                                    action: "read"
                                }
                            }
                        },
                        {
                            path: 'completed',
                            name: 'job-list-completed',
                            component: JobListCompleted,
                            meta: {
                                title: 'Job List',
                                roles: {
                                    access: "job_list",
                                    action: "read"
                                }
                            }
                        },
                        {
                            path: 'expired',
                            name: 'job-list-expired',
                            component: JobListExpired,
                            meta: {
                                title: 'Job List',
                                roles: {
                                    access: "job_list",
                                    action: "read"
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: "job-checklist",
                            component: ChecklistV2,
                            meta: {
                                label: 'Job and Checklist',
                                title: 'Job and Checklist',
                                roles: {
                                    access: "job_list",
                                    action: "read"
                                }
                            }
                        },
                    ]
                },
                {
                    path: 'job-list-dev/:id',
                    component: CheckListForDev,
                    meta: {
                        label: 'Job and Checklist',
                        title: 'Job and Checklist',
                        roles: {
                            access: "job_list",
                            action: "read"
                        }
                    }
                },
                {
                    path: 'job-list-map',
                    component: JobMap,
                    meta: {
                        label: 'Job List - Map',
                        title: 'Job List - Map',
                        roles: {
                            access: "job_list",
                            action: "read"
                        }
                    }
                },
                {
                    path: 'maintenance-schedule',
                    redirect: '/v2/maintenance-schedule/',
                    meta: { label: 'Maintenance Schedule' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                        path: '',
                        name: 'maintenance-schedule',
                        component: JobCalendar,
                        meta: {
                            title: 'Maintenance Schedule',
                            roles: {
                                access: "maintenance_schedule",
                                action: "read"
                            }
                        }
                    }, ]
                },
                {
                    path: 'job-list-soft-fm',
                    redirect: '/v2/job-list-soft-fm/',
                    meta: { label: 'Job List - Soft FM' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                        path: '',
                        name: 'job-list-soft-fm',
                        component: propertySchedule,
                        meta: {
                            title: 'Job List - Soft FM',
                            roles: {
                                access: "joblist_soft_fm",
                                action: "read"
                            }
                        }
                    }, ]
                },
                {
                    path: 'issue-register',
                    redirect: '/v2/issue-register/',
                    meta: { label: 'Issue Register List' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            name: 'issue-register',
                            component: IssueRegisterList,
                            meta: {
                                title: 'Issue Register List',
                                roles: {
                                    access: "issue_register",
                                    action: "read"
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'issue-register-detail',
                            component: IssueRegisterDetail,
                            meta: {
                                label: 'Issue Register Detail',
                                title: 'Issue Register Detail',
                                roles: {
                                    access: "issue_register",
                                    action: "read"
                                }
                            }
                        }
                    ]
                },
                {
                    path: 'issue-register-list',
                    redirect: '/v2/issue-register-list',
                    meta: { label: 'Issue Register List' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                        path: '',
                        name: 'job-list',
                        component: IssueRegisterList,
                        meta: { title: 'Issue Register List' }
                    }]
                },
                {
                    path: 'maintenance-program',
                    redirect: '/v2/maintenance-program/',
                    meta: { label: 'Maintenance List' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: MaintProgramMasterV2,
                            meta: {
                                title: 'Maintenance List',
                                roles: {
                                    access: "maintenance_program",
                                    action: "read"
                                }
                            }
                        },
                        {
                            path: ':maintenance_id',
                            redirect: '/maintenance-program/:maintenance_id/',
                            meta: { label: 'Program' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [{
                                    path: '',
                                    component: MaintProgramInfoV2,
                                    name: "maintenance-program-info-all",
                                    meta: {
                                        label: 'Info',
                                        title: 'Maintenance Program - Info',
                                        roles: {
                                            access: "maintenance_program",
                                            action: "read"
                                        }
                                    },

                                },
                                {
                                    path: 'schedule',
                                    component: MaintProgramScheduleV2,
                                    meta: {
                                        label: 'Schedule',
                                        title: 'Maintenance Program - Schedule',
                                        roles: {
                                            access: "maintenance_program",
                                            action: "read"
                                        }
                                    }
                                },
                                {
                                    path: 'equipment-schedule',
                                    component: MaintProgramEquipmentSchedule,
                                    meta: {
                                        label: 'Equipment Schedule',
                                        title: 'Maintenance Program - Equipment Schedule',
                                        roles: {
                                            access: "maintenance_program",
                                            action: "read"
                                        }
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    path: 'master-service-category',
                    component: MServiceCategory,
                    meta: {
                        label: 'Master Service Category',
                        title: 'Master setting - Service Category',
                        roles: {
                            access: "checklist_template_master",
                            action: "read"
                        }
                    }
                },
                {
                    path: 'master-checklist-template',
                    meta: {
                        label: 'Master Checklist Template',
                        title: 'Master setting - Checklist Template',
                        roles: {
                            access: "checklist_template_master",
                            action: "read"
                        }
                    },
                    redirect: '/v2/master-service-category',
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: MasterChecklist,
                            meta: {
                                title: 'Master setting - Checklist Template',
                                roles: {
                                    access: "checklist_template_master",
                                    action: "read"
                                }
                            },

                        },
                        {
                            path: ':checklist_id',
                            component: MasterChecklistDetail,
                            meta: {
                                label: 'Detail',
                                title: 'Master setting - Checklist Template',
                                roles: {
                                    access: "checklist_template_master",
                                    action: "read"
                                }
                            },
                        }
                    ]
                },
                {
                    path: 'maintenance-standard',
                    meta: {
                        label: 'Maintenance Standard',
                        title: 'Master setting - Maintenance Standard',
                        roles: {
                            access: "maintenance_standard",
                            action: "read"
                        }
                    },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: MaintenanceStandard,
                            meta: {
                                label: 'Maintenance Standard',
                                title: 'Master setting - Maintenance Standard',
                                roles: {
                                    access: "maintenance_standard",
                                    action: "read"
                                }
                            },
                        },
                        {
                            path: ':maintenance_id',
                            name: 'maintenance_standard_detail',
                            meta: {
                                label: 'Maintenance Standard Detail',
                                title: 'Detail - Maintenance Standard',
                                roles: {
                                    access: "maintenance_standard",
                                    action: "read"
                                }
                            },
                            component: MaintenanceStandardDetail,
                        }
                    ]
                },
                {
                    path: 'master-equipment-structure',
                    component: MEquipmentStructure,
                    meta: {
                        label: 'Master Equipment Structure',
                        title: 'Master setting - Equipment Structure',
                        roles: {
                            access: "master_equipment_structure",
                            action: "read"
                        }
                    }
                },
                {
                    path: 'master-priority-set',
                    component: MasterPrioritySet,
                    meta: {
                        label: 'Master Priority Set',
                        title: 'Master setting - Master Priority Set',
                        roles: {
                            access: "master_priority_set",
                            action: "read"
                        }
                    }
                },
                {
                    path: 'master-brands',
                    component: MasterBrands,
                    meta: {
                        label: 'Master Brands',
                        title: 'Master setting - Master Brands',
                        roles: {
                            access: "master_brands",
                            action: "read"
                        }
                    }
                },
                {
                    path: 'tax-versioning',
                    redirect: '/tax-versioning/',
                    meta: { label: 'Tax And Versioning' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: TaxVersioning,
                            meta: {
                                title: 'Tax And Versioning',
                                roles: {
                                    access: "tax_and_versioning",
                                    action: "read"
                                }
                            },
                        },
                        {
                            path: ':tax_id',
                            meta: {
                                label: 'Tax And Versioning Detail',
                                title: 'Tax And Versioning Detail',
                                roles: {
                                    access: "tax_and_versioning",
                                    action: "read"
                                }
                            },
                            component: TaxDetail,
                        }
                    ]
                },
                {
                    path: 'general-ledger',
                    redirect: '/general-ledger/',
                    meta: { label: 'Finance' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: GeneralLedger,
                            meta: {
                                label: 'General Ledger',
                                title: 'General Ledger',
                                roles: {
                                    access: "general_ledger",
                                    action: "read"
                                }
                            },
                        },
                        {
                            path: ':id',
                            component: GeneralLedgerInfo,
                            meta: {
                                label: 'General Ledger Info',
                                title: 'General Ledger Info'
                            },
                        }
                    ]
                },
                {
                    path: 'misc-expenses',
                    redirect: '/misc-expenses/',
                    meta: {
                        label: 'Misc Expenses',
                    },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: MiscExpenses,
                            meta: {
                                title: 'Misc Expenses',
                                roles: {
                                    access: "misc_expenses",
                                    action: "read"
                                }
                            },
                        },
                        {
                            path: ':id',
                            component: MiscExpensesDetail,
                            meta: {
                                label: 'Misc Expenses Detail',
                                title: 'Misc Expenses Detail',
                                roles: {
                                    access: "misc_expenses",
                                    action: "read"
                                }
                            },
                        }
                    ]
                },
                {
                    path: 'liquidated-damages',
                    redirect: '/liquidated-damages/',
                    meta: {
                        label: 'Liquidated Damages',
                    },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: LiquidatedDamagesList,
                            meta: {
                                title: 'Liquidated Damages',
                                roles: {
                                    access: "liquidated_damages",
                                    action: "read"
                                }
                            },
                        },
                        {
                            path: ':id',
                            component: LiquidatedDamagesDetail,
                            name: "liquidated-damages-detail",
                            meta: {
                                label: 'Liquidated Damages Detail',
                                title: 'Liquidated Damages Detail',
                                roles: {
                                    access: "liquidated_damages",
                                    action: "read"
                                }
                            },
                        }
                    ]
                },
                {
                    path: 'asset-management',
                    meta: {
                        label: 'Lift Inspection Scheduling',
                        title: "Lift Inspection Scheduling",
                        roles: {
                            access: "lift_inspection_scheduling",
                            action: "read"
                        }
                    },
                    component: assetManagement,
                },
                {
                    path: 'parts-replacement',
                    redirect: '/parts-replacement/',
                    meta: {
                        label: 'Parts Replacement Records',
                    },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: PartsReplacementHistory,
                            meta: {
                                title: 'Parts Replacement Records',
                                roles: {
                                    access: "parts_replacement",
                                    action: "read"
                                }
                            }
                        },
                        {
                            path: ':part_replacement_id',
                            component: PartsReplacementDetail,
                            name: "parts-replacement-detail",
                            meta: {
                                label: 'Parts Replacement Detail',
                                title: 'Parts Replacement Detail',
                                roles: {
                                    access: "parts_replacement",
                                    action: "read"
                                }
                            }
                        }
                    ]
                },
                {
                    path: 'incoming-documents',
                    redirect: '/incoming-documents/',
                    meta: {
                        label: 'Incoming Documents',
                    },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: IncomingDocuments,
                            meta: {
                                title: 'Incoming Documents',
                                roles: {
                                    access: "incoming_documents",
                                    action: "read"
                                }
                            }
                        },
                        {
                            path: ':id',
                            component: IncomingDocumentsDetail,
                            name: "incoming-documents-detail",
                            meta: {
                                label: 'Incoming Documents Detail',
                                title: 'Incoming Documents Detail',
                                roles: {
                                    access: "incoming_documents",
                                    action: "read"
                                }
                            }
                        },
                    ]
                },
                {
                    path: 'posting-rules',
                    redirect: '/posting-rules/',
                    meta: { label: 'Posting Rules' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                        path: '',
                        component: PostingRules,
                        meta: {
                            title: 'Posting Rules List',
                            roles: {
                                access: "posting_rules",
                                action: "read"
                            }
                        },
                    }]
                },
                {
                    path: 'payment-voucher',
                    redirect: '/payment-voucher/',
                    meta: { label: 'Finance' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: PaymentVouchers,
                            meta: {
                                label: 'Payment Voucher',
                                title: 'Payment Voucher',
                                roles: {
                                    access: "payment_voucher",
                                    action: "read"
                                }
                            },
                        },
                        {
                            path: 'add',
                            component: PaymentVoucherInfo,
                            meta: {
                                label: 'Payment Voucher Detail',
                                title: 'Payment Voucher',
                                roles: {
                                    access: "payment_voucher",
                                    action: "read"
                                }
                            },
                        },
                        {
                            path: ':payment_id',
                            component: PaymentVoucherInfo,
                            name: 'payment-voucher-detail',
                            meta: {
                                label: 'Payment Voucher Detail',
                                title: 'Payment Voucher',
                                roles: {
                                    access: "payment_voucher",
                                    action: "read"
                                }
                            },
                        }
                    ]
                },
                {
                    path: 'ap-invoice',
                    redirect: '/ap-invoice/',
                    meta: { label: 'AP INVOICE' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: ApInvoices,
                            meta: {
                                title: 'AP INVOICE',
                                roles: {
                                    access: "ap_invoice",
                                    action: "read"
                                }
                            },
                        },
                        {
                            path: ':apinvoice_id',
                            component: ApInvoicesInfo,
                            name: 'ap-invoice-detail',
                            meta: {
                                label: 'AP INVOICE DETAIL',
                                title: 'AP INVOICE',
                                roles: {
                                    access: "ap_invoice",
                                    action: "read"
                                }
                            },
                        }
                    ]
                },
                {
                    path: 'navision-file',
                    meta: {
                        label: 'Navision File Listing',
                        title: "Navision File Listing",
                        roles: {
                            access: "navision_file_listing",
                            action: "read"
                        }
                    },
                    component: NavisionFiles,
                },
                {
                    path: 'navision-file-config',
                    meta: {
                        label: 'Navision File Config',
                        title: "Navision File Config",
                        roles: {
                            access: "navision_file_config",
                            action: "read"
                        }
                    },
                    component: NavisionFilesConfig,
                },
                {
                    path: 'master-gl-account',
                    meta: { label: 'Master GL Account', title: "Finance - Master GL Account" },
                    component: MasterGLAccount,
                },
                {
                    path: 'chart-of-account',
                    meta: {
                        label: 'Chart Of Account',
                        title: "Finance - Chart Of Account",
                        roles: {
                            access: "chart_of_account",
                            action: "read"
                        }
                    },
                    component: ChartOfAccount,
                },
                {
                    path: 'water-meter',
                    redirect: '/water-meter/',
                    meta: { label: 'Water Meter Listing' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: Meter,
                            meta: {
                                title: 'Water Meter Listing',
                                roles: {
                                    access: "water_meter_listing",
                                    action: "read"
                                }
                            },
                        },
                        {
                            path: ':id',
                            component: MeterInfo,
                            meta: {
                                label: 'Detail',
                                title: 'Water Meter Detail',
                                roles: {
                                    access: "water_meter_listing",
                                    action: "read"
                                }
                            },
                        },
                    ]
                },
                {
                    path: 'app-version',
                    meta: {
                        label: 'App Version',
                        title: 'App Version',
                        roles: {
                            access: "mobile_app_versioning",
                            action: "read"
                        }
                    },
                    component: AppVersion,
                },
                {
                    path: 'water-reading-logs',
                    meta: {
                        label: 'Water Reading Log',
                        title: 'Water Reading Log',
                        roles: {
                            access: "water_reading_log",
                            action: "read"
                        }
                    },
                    component: ReadingLog,
                },
                {
                    path: 'feedback',
                    redirect: '/feedback-listing/',
                    meta: { label: 'Feedback Listing' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: Feedbacks,
                            meta: { title: 'Feedback Listing' },
                        },
                        {
                            path: ':id',
                            component: FeedbackDetail,
                            meta: { label: 'Feedback Detail', title: 'Feedback Detail' },
                        },
                    ]
                },
                {
                    path: 'vendor-linking',
                    redirect: '/vendor-linking/',
                    meta: { label: 'Vendor Linking' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: VendorLinking,
                            meta: {
                                title: 'Vendor Linking',
                                roles: {
                                    access: "vendor_linking",
                                    action: "read"
                                }
                            },
                        },
                        {
                            path: ':id',
                            component: VendorLinkingDetail,
                            meta: {
                                label: 'Vendor Linking Detail',
                                title: 'Vendor Linking Detail',
                                roles: {
                                    access: "vendor_linking",
                                    action: "read"
                                }
                            },
                        },
                    ]
                },
                {
                    path: 'reference-table',
                    component: Reference,
                    meta: { title: 'Reference Table', label: 'Reference Table', 
                        roles: {
                            access: "reference_table",
                            action: "read"
                        }
                    }
                },
                {
                    path: 'default-column-settings',
                    component: DefaultColumnSetting,
                    meta: { title: 'Column Settings', label: 'Column Settings',
                        roles: {
                            access: "web_column_setting",
                            action: "read"
                        }
                    }
                },
                {
                    path: 'case',
                    redirect: '/case/',
                    meta: { label: 'Case List' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: CasesAll,
                            name: "case-all",
                            meta: {
                                title: 'Case Listing',
                                roles: {
                                    access: "case_management",
                                    action: "read"
                                }
                            },
                        },
                        {
                            path: 'opening',
                            component: CasesOpening,
                            name: "case-opening",
                            meta: {
                                title: 'Case Listing',
                                roles: {
                                    access: "case_management",
                                    action: "read"
                                }
                            },
                        },
                        {
                            path: 'closed',
                            component: CasesClosed,
                            name: "case-closed",
                            meta: {
                                title: 'Case Listing',
                                roles: {
                                    access: "case_management",
                                    action: "read"
                                }
                            },
                        },
                        {
                            path: 'hot-button/:id',
                            name: "case-detail-hb-info",
                            component: CaseHBDetail,
                            meta: {
                                label: 'Case Info',
                                title: 'Case Info',
                                roles: {
                                    access: "case_management",
                                    action: "read"
                                }
                            },
                        },
                        {
                            path: ':id',
                            name: "case-detail-info",
                            component: CaseDetail,
                            meta: {
                                label: 'Case Info',
                                title: 'Case Info',
                                roles: {
                                    access: "case_management",
                                    action: "read"
                                }
                            },
                        },
                        {
                            path: ':id/:email_id',
                            name: "case-detail-email-id",
                            component: CaseDetail,
                            meta: {
                                label: 'Case Info',
                                title: 'Case Info',
                                roles: {
                                    access: "case_management",
                                    action: "read"
                                }
                            },
                        },
                    ]
                },

                {
                    path: 'budget',
                    redirect: '/budget/',
                    meta: { label: 'BUDGET' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: BudgetList,
                            meta: {
                                title: 'Budget'
                            },
                        },
                        {
                            path: ':id',
                            redirect: '/budget/:id/',
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [{
                                    path: '',
                                    meta: {
                                        title: 'Budget Detail',
                                        label: 'Budget Detail'
                                    },
                                    component: BudgetDetail,
                                },
                                {
                                    path: 'budget-tracking',
                                    redirect: '/budget/:id/budget-tracking',
                                    meta: { label: 'Budget Tracking' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [{
                                            path: '',
                                            meta: {
                                                title: 'Budget Tracking'
                                            },
                                            component: BudgetTrackingDetail,
                                        },
                                        {
                                            path: ':detail',
                                            meta: {
                                                title: 'Budget Tracking Detail',
                                                label: 'Budget Tracking Detail'
                                            },
                                            component: BudgetTrackingDetailInfo,
                                        }
                                    ]
                                }
                            ]
                        },
                    ]
                },
                {
                    path: 'user-duty',
                    name: 'user-duty',
                    component: UserDuty,
                    meta: {
                        requiresAuth: true,
                        title: "User Duty",
                        label: "User Duty",
                        roles: {
                            access: "user_duty",
                            action: "read"
                        },
                    },
                },
                {
                    path: 'user-access-report',
                    component: UserAccessReport,
                    meta: {
                        label: 'User Access Report',
                        title: 'User Access Report',
                        roles: {
                            access: "users_access_report",
                            action: "read"
                        }
                    }
                },
                {
                    path: 'audit-duty-assignment',
                    meta: { label: 'Audit Trail - Duty Assignment', title: 'Audit Trail - Duty Assignment',
                        roles: {
                            access: "allow_can_view_audit_trail_duty_assignment",
                            action: "allow_can_view_audit_trail_duty_assignment"
                        }
                    },
                    component: AuditTrailDuty

                },
                {
                    path: 'audit-trail-user-activities',
                    meta: { label: 'Audit Trail - User Activities', title: 'Audit Trail - User Activities',
                        roles: {
                            access: "allow_can_view_audit_trail_user_activities",
                            action: "allow_can_view_audit_trail_user_activities"
                        }
                    },
                    component: AuditTrailUserActivities
                },
                {
                    path: 'audit-trail-role',
                    meta: { label: 'Audit trail - Role Setup', title: 'Audit trail - Role Setup',
                        roles: {
                            access: "allow_can_view_audit_trail_role_setup",
                            action: "allow_can_view_audit_trail_role_setup"
                        }
                    },
                    component: AuditTrailRole

                },
                {
                    path: 'audit-trail-user-info',
                    meta: { 
                        label: 'Audit Trail - User Info', title: 'Audit Trail - User Info',
                        roles: {
                            access: "allow_can_view_audit_trail_user_info",
                            action: "allow_can_view_audit_trail_user_info"
                        } 
                    },
                    component: AuditTrailUserInfo
                },
                {
                    path: 'requestor-types',
                    component: CaseSettingsRequesterTypeMaster,
                    meta: {
                        label: 'Master - Case Requestor Type',
                        title: 'Master - Case Requestor Type',
                        roles: {
                            access: "master_case_requestor_type",
                            action: "read"
                        }
                    }
                },
                {
                    path: 'config-notification',
                    redirect: '/settings/config-notification/',
                    meta: { label: 'Notification' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: ContractNotificationMaster,
                            meta: {
                                title: 'Notification',
                                roles: {
                                    access: "master_notification_template",
                                    action: "read"
                                }
                            }
                        },
                        {
                            path: 'event-trigger',
                            component: ContractNotificationEvents,
                            meta: {
                                label: 'Notification - Event Trigger',
                                title: 'Notification - Event Trigger',
                                roles: {
                                    access: "master_notification_event_trigger",
                                    action: "read"
                                }
                            }
                        },
                        {
                            path: 'parameters',
                            component: ContractNotificationParameter,
                            meta: {
                                label: 'Notification - Parameters',
                                title: 'Notification - Parameters',
                                roles: {
                                    access: "master_notification_parameter",
                                    action: "read"
                                }
                            }
                        },
                        {
                            path: ':config_notification_id',
                            component: ContractNotificationDetailMaster,
                            meta: {
                                label: 'Detail',
                                title: 'Notification Detail',
                            }
                        },
                    ]
                },
                {
                    path: 'uob-notification',
                    name: 'UOB - Notification',
                    component: UOBNotification,
                    meta: {
                        title: 'UOB - Notification',
                        label: 'UOB - Notification',
                        roles: {
                            access: "uob_notifications",
                            action: "read"
                        }
                    }
                },
                {
                    path: 'uob-payment',
                    name: 'UOB - Invoke Payment',
                    component: UOBPayment,
                    meta: {
                        title: 'UOB - Invoke Payment',
                        label: 'UOB - Invoke Payment',
                    }
                },
                {
                    path: 'uob-generate-qr',
                    name: 'UOB - Generate QR code',
                    component: UOBQRGenerate,
                    meta: {
                        title: 'UOB - Generate QR code',
                        label: 'UOB - Generate QR code',
                        roles: {
                            access: "uob_generate_qr",
                            action: "read"
                        }
                    }
                },
                {
                    path: 'uob-transactions',
                    name: 'UOB - Transactions',
                    component: UOBTransaction,
                    meta: {
                        title: 'UOB - Transactions',
                        label: 'UOB - Transactions',
                        roles: {
                            access: "uob_transactions",
                            action: "read"
                        }
                    }
                },
                {
                    path: 'mapping-report',
                    name: 'Mapping Report',
                    component: MappingReport,
                    meta: {
                        title: 'Mapping Report',
                        label: 'Mapping Report',
                        roles: {
                            access: "mapping_report",
                            action: "read"
                        }
                    }
                },
                {
                    path: 'navision-cronjob',
                    meta: {
                        label: 'Navision Cronjob Setting',
                        title: 'Navision Cronjob Setting',
                        roles: {
                            access: "navision_cronjob_setting",
                            action: "read"
                        }
                    },
                    component: NavisionCronjob
                },
                {
                    path: 'operating-hours',
                    meta: {
                        label: 'Operating Hours',
                        title: 'Operating Hours',
                        roles: {
                            access: "operating_hours",
                            action: "read"
                        }
                    },
                    component: OperatingHoursMaster
                },
                {
                    path: 'password-management',
                    name: 'password-management',
                    component: PasswordManagement,
                    meta: {
                        requiresAuth: true,
                        title: "Password Management",
                        label: "Password Management",
                        roles: {
                            access: "password_management",
                            action: "read"
                        }
                    },
                },
                {
                    path: 'table-purging',
                    component: Purging,
                    meta: { title: 'Table Purging', label: 'Table Purging',
                        roles: {
                            access: "table_purging",
                            action: "read"
                        }
                    }
                },
                {
                    path: 'app-token',
                    meta: {
                        label: 'App Token',
                        title: 'App Token',
                        roles: {
                            access: "app_token",
                            action: "read"
                        }
                    },
                    component: AppToken
                },
                {
                    path: 'batch-submission-summary',
                    redirect: '/batch-submission-summary/',
                    meta: { label: 'Batch Submission Summary' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            component: LMUBatchSubmissionSummary,
                            meta: {
                                title: 'Batch Submission Summary',
                            },
                        },
                        {
                            path: ':id/logs',
                            component: LMUBatchError,
                            meta: {
                                title: 'Batch Log',
                                label: 'Batch Log',
                            }
                        },
                        {
                            path: ':id',
                            component: LMUBatchDetail,
                            meta: {
                                title: 'Batch detail',
                                label: 'Batch detail',
                            }
                        },
                    ]
                },
                {
                    path: 'project-listing',
                    name: 's-contract-schedule',
                    component: SContractSchedule,
                    meta: {
                        label: 'Project Listing',
                        title: "Project Listing"
                    }
                },
                {
                    path: 'offset-documents',
                    redirect: '/offset-documents/',
                    meta: { label: 'Finance' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: OffsetDocuments,
                            meta: {
                                label: 'Offset Documents',
                                title: 'Offset Documents',
                                // roles: {
                                //     access: "payment_voucher",
                                //     action: "read"
                                // }
                            },
                        },
                        {
                            path: ':offset_id',
                            component: OffsetDocumentDetail,
                            name: 'offset-document-detail',
                            meta: {
                                label: 'Offset Document Detail',
                                title: 'Offset Documents',
                                // roles: {
                                //     access: "payment_voucher",
                                //     action: "read"
                                // }
                            },
                        }
                    ]
                },
                {
                    path: 'credit-note',
                    redirect: '/credit-note/',
                    meta: { label: 'Finance' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: CreditNote,
                            meta: {
                                label: 'Credit Note',
                                title: 'Credit Note',
                                // roles: {
                                //     access: "payment_voucher",
                                //     action: "read"
                                // }
                            },
                        },
                        {
                            path: ':credit_note_id',
                            component: CreditNoteDetail,
                            name: 'credit-note-detail',
                            meta: {
                                label: 'Credit Note Detail',
                                title: 'Credit Note',
                                // roles: {
                                //     access: "payment_voucher",
                                //     action: "read"
                                // }
                            },
                        }
                    ]
                },
                {
                    path: 'lift-inspection-calendar',
                    component: LiftInspectionCalendar,
                    meta: {
                        title: "Lift Inspection Calendar",
                        label: "Lift Inspection Calendar",
                    },
                },
                {
                    path: 'safety-inspection-checklist',
                    redirect: '/safety-inspection-checklist/',
                    meta: { label: 'Safety App' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: SafetyInspectionChecklist,
                            name: 'safety-inspection-checklist-list',
                            meta: {
                                label: 'Safety Inspection Checklist',
                                title: 'Safety Inspection Checklist',
                                roles: {
                                    access: "safety_inspection_checklist",
                                    action: "read"
                                }
                            },
                        },
                        {
                            path: ':id',
                            component: SafetyInspectionChecklistDetail,
                            name: 'safety-inspection-checklist-detail',
                            meta: {
                                label: 'Safety Inspection Checklist Detail',
                                title: 'Safety Inspection Checklist Detail',
                                roles: {
                                    access: "safety_inspection_checklist",
                                    action: "read"
                                }
                            },
                        }
                    ]
                },
                {
                    path: 'permit-to-work',
                    redirect: '/permit-to-work/',
                    meta: { label: 'Safety App' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: SafetyPermitToWork,
                            name: 'permit-to-work-list',
                            meta: {
                                label: 'Permit To Work',
                                title: 'Permit To Work',
                                roles: {
                                    access: "permit_to_work",
                                    action: "read"
                                }
                            },
                        },
                        {
                            path: ':id',
                            component: SafetyPermitToWorkDetail,
                            name: 'permit-to-work-detail',
                            meta: {
                                label: 'Permit To Work Detail',
                                title: 'Permit To Work Detail',
                                roles: {
                                    access: "permit_to_work",
                                    action: "read"
                                }
                            },
                        }
                    ]
                },
                {
                    path: 'non-conformance-report',
                    redirect: '/non-conformance-report/',
                    meta: { label: 'Safety App' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: SafetyNonConformanceReport,
                            name: 'non-conformance-report-list',
                            meta: {
                                label: 'Non Conformance Report',
                                title: 'Non Conformance Report',
                                roles: {
                                    access: "non_conformance_report",
                                    action: "read"
                                }
                            },
                        },
                        {
                            path: ':id',
                            component: SafetyNonConformanceReportDetail,
                            name: 'non-conformance-report-detail',
                            meta: {
                                label: 'Non Conformance Report Detail',
                                title: 'Non Conformance Report Detail',
                                roles: {
                                    access: "non_conformance_report",
                                    action: "read"
                                }
                            },
                        }
                    ]
                },
                {
                    path: 'safety-induction-training',
                    redirect: '/safety-induction-training/',
                    meta: { label: 'Safety App' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: SafetyInductionTraining,
                            name: 'safety-induction-training-list',
                            meta: {
                                label: 'Safety Induction Training',
                                title: 'Safety Induction Training',
                                roles: {
                                    access: "safety_induction_training",
                                    action: "read"
                                }
                            },
                        },
                        {
                            path: ':id',
                            component: SafetyInductionTrainingDetail,
                            name: 'safety-induction-training-detail',
                            meta: {
                                label: 'Safety Induction Training Detail',
                                title: 'Safety Induction Training Detail',
                                roles: {
                                    access: "safety_induction_training",
                                    action: "read"
                                }
                            },
                        }
                    ]
                },
                {
                    path: 'toolbox-meeting',
                    redirect: '/toolbox-meeting/',
                    meta: { label: 'Safety App' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: SafetyToolboxMeeting,
                            name: 'safety-toolbox-meeting',
                            meta: {
                                label: 'Safety Toolbox Meeting',
                                title: 'Safety Toolbox Meeting',
                                roles: {
                                    access: "toolbox_meeting",
                                    action: "read"
                                }
                            },
                        },
                        {
                            path: ':id',
                            component: SafetyToolboxMeetingDetail,
                            name: 'safety-toolbox-meeting-detail',
                            meta: {
                                label: 'Safety Toolbox Meeting Detail',
                                title: 'Safety Toolbox Meeting Detail',
                                roles: {
                                    access: "toolbox_meeting",
                                    action: "read"
                                }
                            },
                        }
                    ]
                },
                {
                    path: 'forms',
                    name: 'form-input',
                    component: FormInputs,
                    meta: {
                        title: "Form Inputs",
                        label: "Form Inputs",
                    },
                },
                {
                    path: 'buttons',
                    name: 'buttons',
                    component: Buttons,
                    meta: {
                        title: "Buttons",
                        label: "Buttons",
                    },
                },
                {
                    path: 'tabs',
                    name: 'Tabs',
                    component: Tabs,
                    meta: {
                        title: "Tabs",
                        label: "Tabs",
                    },
                },
                {
                    path: 'tenant-site',
                    component: TenantSiteListing,
                    meta: {
                        label: 'Tenant sites',
                        title: 'Tenant sites',
                        roles: {
                            access: "tenant_site",
                            action: "read"
                        }
                    }
                },
                {
                    path: 'contact-site',
                    component: ContactSiteListing,
                    meta: {
                        label: 'Contact sites',
                        title: 'Contact sites',
                        roles: {
                            access: "tenant_site",
                            action: "read"
                        }
                    }
                },
                {
                    path: 'profile',
                    component: ProfileUser,
                    meta: {
                        label: 'User Profile',
                        title: 'User Profile',
                    }
                },
                {
                    path: 'approval-template',
                    name: 'approval-template',
                    component: ApprovalTemplate,
                    meta: {
                        requiresAuth: true,
                        title: "Approval Template",
                        label: "Approval Template",
                        roles: {
                            access: "approval_template",
                            action: "read"
                        }
                    },
                },
                // Performance Assesment
                {
                    path: 'performance-assessment',
                    redirect: '/v2/performance-assessment/data-entry-po',
                    meta: {
                        label: 'Performance Assessment',
                    },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: 'settings',
                            component: PerformanceAssesmentSettings,
                            meta: {
                                label: 'Settings',
                                title: 'Performance Assessment Settings'
                            }
                        },
                        {
                            path: 'data-entry-po',
                            component: PAEntryPO,
                            meta: {
                                label: 'Data Entry PO',
                                title: 'Data Entry PO'
                            }
                        },
                        {
                            path: 'report',
                            component: PerformanceAssesmentReport,
                            meta: {
                                title: 'Report',
                                label: 'Report',
                            }
                        },
                        {
                            path: 'data-entry-maintenance-regime',
                            component: PAEntryMaintenanceRegime,
                            meta: {
                                title: 'Performance Assessment - Maintenance Regime'
                            }
                        },
                        {
                            path: 'data-entry-other-sources',
                            component: PAEntryOtherSources,
                            meta: {
                                title: 'Performance Assessment - Other Sources'
                            }
                        },
                        {
                            path: 'data-entry-rates-of-deduction',
                            component: PAEntryRatesOfDeduction,
                            meta: {
                                title: 'Performance Assessment - Rates of Deduction'
                            }
                        },
                    ]
                },
                {
                    path: 'approval-request',
                    redirect: '/approval-request/',
                    meta: { label: 'Approval Request' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: ApprovalRequestFMOfficer,
                            meta: {
                                title: 'Approval Request',
                                roles: {
                                    access: "approval_request",
                                    action: "read"
                                }
                            },
                        },
                        {
                            path: ':id',
                            name: 'fm-defect-report-detail',
                            component: ApprovalRequestFMOfficerDetail,
                            meta: {
                                label: 'Approval Request Detail',
                                title: 'Approval Request Detail',
                                roles: {
                                    access: "approval_request",
                                    action: "read"
                                }
                            },
                        },
                    ]
                },
                {
                    path: 'lmu-notification',
                    redirect: '/lmu-notification/',
                    meta: { label: 'Notification' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            component: LMUNotification,
                            meta: {
                                title: 'Notification',
                            },
                        },
                        {
                            path: ':id',
                            component: LMUNotificationDetail,
                            meta: {
                                title: 'Notification Detail',
                                label: 'Notification Detail',
                            }
                        },
                    ]
                },
                {
                    path: 'lmu-address-book',
                    redirect: '/v2/lmu-address-book/',
                    meta: { label: 'Address Book' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: LMUAddressBook,
                            meta: {
                                title: 'Address Book'
                            },
                        },
                    ]
                },
                {
                    path: '403-forbidden',
                    component: Page403,
                    meta: {
                        title: '403 Forbidden',
                        requiresAuth: true
                    }
                },
                {
                    path: 'electricity-meter',
                    redirect: '/electricity-meter/',
                    meta: { label: 'Electricity Meter Listing' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: ElectricityMeter,
                            meta: {
                                title: 'Electricity Meter Listing',
                                roles: {
                                    access: "electricity_meter_listing",
                                    action: "read"
                                }
                            },
                        },
                        {
                            path: ':id',
                            component: ElectricityMeterInfo,
                            meta: {
                                label: 'Detail',
                                title: 'Electricity Meter Detail',
                                roles: {
                                    access: "electricity_meter_listing",
                                    action: "read"
                                }
                            },
                        },
                    ]
                },
                {
                    path: 'electricity-reading-logs',
                    meta: {
                        label: 'Electricity Reading Log',
                        title: 'Electricity Reading Log',
                        roles: {
                            access: "electricity_reading_log",
                            action: "read"
                        }
                    },
                    component: ElectricityReadingLog,
                },
                // Garuda Integration
                {
                    path: 'garuda-facilities-properties',
                    component: GarudaFacilitiesProperties,
                    meta: {
                        label: 'Garuda Facilities Properties',
                        title: 'Garuda Facilities Properties',
                    },
                },
                {
                    path: 'garuda-inspections-jobs',
                    component: GarudaInspectionsJobs,
                    meta: {
                        label: 'Garuda Inspections Jobs',
                        title: 'Garuda Inspections Jobs',
                    },
                }
            ],
        },
        {
            path: '/supplier-portal',
            redirect: '/supplier-portal/dashboard',
            meta: {
                requiresAuth: true,
                supplier_portal: true,
                metaTags: [{
                    name: 'viewport',
                    content: 'width=1366,initial-scale=1'
                }, ]
            },
            component: DefaultContainerLMU,
            children: [
                {
                    path: 'dashboard',
                    component: DashboardLMU,
                    meta: { 
                        title: 'Dashboard',
                        label: 'Dashboard',
                        supplier_portal: true,
                    }
                },
                {
                    path: 'parts-replacement',
                    redirect: '/parts-replacement/',
                    meta: {
                        label: 'Parts Replacement Records',
                    },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: PartsReplacementHistory,
                            meta: {
                                title: 'Parts Replacement Records',
                                supplier_portal: true,
                                roles: {
                                    access: "parts_replacement",
                                    action: "read"
                                }
                            }
                        },
                        {
                            path: ':part_replacement_id',
                            component: PartsReplacementDetail,
                            name: "parts-replacement-detail-lmu",
                            meta: {
                                label: 'Parts Replacement Detail',
                                title: 'Parts Replacement Detail',
                                supplier_portal: true,
                                roles: {
                                    access: "parts_replacement",
                                    action: "read"
                                }
                            }
                        }
                    ]
                },
                {
                    path: 'config-notification',
                    redirect: '/config-notification/',
                    meta: { label: 'Notification' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            component: LMUNotification,
                            meta: {
                                title: 'Notification',
                                supplier_portal: true,
                            },
                        },
                        {
                            path: ':id',
                            component: LMUNotificationDetail,
                            meta: {
                                title: 'Add',
                                label: 'Add',
                                supplier_portal: true,
                            }
                        },
                    ]
                },
                {
                    path: 'profile',
                    component: ProfileUser,
                    meta: {
                        label: 'User Profile',
                        title: 'User Profile',
                        supplier_portal: true,
                    }
                },
                {
                    path: 'import-logs',
                    component: ImportLogsLMU,
                    meta: {
                        label: 'Import Logs',
                        title: 'Import Logs',
                        supplier_portal: true,
                    }
                },
                {
                    path: 'batch-submission-summary',
                    redirect: '/batch-submission-summary/',
                    meta: { label: 'Batch Submission Summary' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            component: LMUBatchSubmissionSummary,
                            meta: {
                                title: 'Batch Submission Summary',
                                supplier_portal: true,
                            },
                        },
                        {
                            path: ':id/logs',
                            component: LMUBatchError,
                            meta: {
                                title: 'Batch Log',
                                label: 'Batch Log',
                                supplier_portal: true,
                            }
                        },
                        {
                            path: ':id',
                            component: LMUBatchDetail,
                            meta: {
                                title: 'Batch detail',
                                label: 'Batch detail',
                                supplier_portal: true,
                            }
                        },
                    ]
                },
                {
                    path: 'approval-request',
                    redirect: '/approval-request/',
                    meta: { label: 'Approval Request' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: ApprovalRequestSupplier,
                            meta: {
                                title: 'Approval Request',
                                supplier_portal:true,
                                roles: {
                                    access: "approval_request",
                                    action: "read"
                                }
                            },
                        },
                        {
                            path: ':id',
                            name: 'supplier-defect-report-detail',
                            component: ApprovalRequestSupplierDetail,
                            meta: {
                                label: 'Approval Request Detail',
                                title: 'Approval Request Detail',
                                supplier_portal:true,
                                roles: {
                                    access: "approval_request",
                                    action: "read"
                                }
                            },
                        },
                    ]
                },
                {
                    path: '403-forbidden',
                    component: Page403,
                    meta: {
                        title: '403 Forbidden',
                        requiresAuth: true
                    }
                },
                {
                    path: 'files',
                    redirect: '/supplier-portal/files/',
                    meta: { label: 'Files', title: 'Files' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: FilePreview,
                            meta: {
                                title: 'Files',
                                roles: {
                                    access: "companies",
                                    action: "read"
                                },
                                supplier_portal: true,
                            },
                        },
                        {
                            path: ':file_id',
                            name: 'Supplier Portal FilePreview',
                            component: FilePreview,
                            meta: { label: 'File Preview', title: 'File Preview', supplier_portal: true, }
                        }
                    ]
                },
            ]
        },    
        {
            path: '/tenants',
            redirect: '/tenants',
            component: TenantsContainer,
            children: [{
                path: '',
                component: TenantFeedback,
                meta: {
                    title: 'Tenants Feedback',
                    metaTags: [{
                        name: 'viewport',
                        content: 'width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=0'
                    }, ]
                }
            }, ],
        },
        {
            path: '/lmu-approval-form',
            redirect: '/lmu-approval-form',
            component: LMUApprovalForm,
            children: [{
                path: '',
                component: LMUApprovalFormDetail,
                name: "lmu-approval-form",
                meta: {
                    title: 'Approval Request Form',
                    label: 'Approval Request Form',
                    requiresAuth: true,
                    supplier_portal: true,
                    metaTags: [{
                        name: 'viewport',
                        content: 'width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=0'
                    }]
                }
            }, ],
        },
        {
            path: '/briefing-register',
            redirect: '/briefing-register',
            component: TenantsContainer,
            children: [{
                path: '',
                component: SafetyBriefingRegisterForm,
                name: "briefing-register",
                meta: {
                    title: 'Briefing Register Form',
                    label: 'Briefing Register Form',
                    metaTags: [{
                        name: 'viewport',
                        content: 'width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=0'
                    }]
                }
            }, ],
        },
    ]
})

const DEFAULT_TITLE = 'Home';
const LOGIN_REDIRECT_LINKS = [
    "case-detail",
    "work-order-info",
    "payment-voucher-detail",
    "ap-invoice-detail",
    "job-checklist",
    "fm-defect-report-detail",
    "supplier-defect-report-detail",
    "lmu-approval-form",
    "case-detail-hb-info",
    "safety-inspection-checklist-detail",
    "non-conformance-report-detail",
    "permit-to-work-detail",
];
router.beforeEach(async(to, from, next) => {
    // document.title = to.meta.title || 'Loading...';
    const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
    const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
    //Check login screen
    let token = localStorage.getItem('access_token') || '';
    if (to.path === '/login') {
        document.title = to.meta.title;
        if (token) {
            if(!router.app.$options.methods.$checkTwoFactorAuth()){
                next(`/two-factor-authentication`);
                return;
            }
            // if(router.app.$options.methods.$checkSupplier()){
            //     next(`/supplier-portal/dashboard`);
            //     return;
            // }
            next(`/v2/dashboard`);
            return;
        }
    }
    //
    if (nearestWithMeta) {
        nearestWithMeta.meta.metaTags.map(tagDef => {
                const tag = document.createElement('meta');
                Object.keys(tagDef).forEach(key => {
                    tag.setAttribute(key, tagDef[key]);
                });
                tag.setAttribute('data-vue-router-controlled', '');
                return tag;
            })
            .forEach(tag => document.head.appendChild(tag));
    }
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if(token){
            try {
                router.app.$store.dispatch("AuthController/getRoles");
                if(!localStorage.getItem('user_info') || !store.getters['AuthController/user'] || !Object.keys(store.getters['AuthController/user']).length){
                    await router.app.$store.dispatch("AuthController/getUser")
                }
            } catch (error) {
                console.log(error);
            }
        }
        if(to.path !== '/login' && token && to.path !== '/two-factor-authentication'){
            if(!router.app.$options.methods.$checkTwoFactorAuth()){
                next(`/two-factor-authentication`);
                return;
            }
            if(to.path !== '/'){
                if(to.meta.supplier_portal) {
                    if(!router.app.$options.methods.$checkSupplier()) {
                        next(`/v2/dashboard`);
                        return;
                    }
                } else {
                    // if(router.app.$options.methods.$checkSupplier()) {
                    //     next(`/supplier-portal/dashboard`);
                    //     return;
                    // }
                }
                // if((!router.app.$options.methods.$checkSupplier() && to.meta.supplier_portal) || 
                // (router.app.$options.methods.$checkSupplier() && !to.meta.supplier_portal)){
                //     next(`/v2/dashboard`);
                //     return;
                // }
            }
        }
        if(token && to.path === '/two-factor-authentication' && router.app.$options.methods.$checkTwoFactorAuth()){
            next(`/v2/dashboard`);
            return;
        }
        if (to.matched.some(record => record.meta.roles)) {
            if (router.app.$options.methods.$checkRole(router.app.$accessModule[to.meta.roles.access], to.meta.roles.action)) {
                next();
            } else {
                if (!store.getters['AuthController/isLoggedIn']) {
                    if (LOGIN_REDIRECT_LINKS.includes(to.name)) {
                        next({ name: "GOfix FM-Commercial - Login", query: { from: to.fullPath } });
                    } else {
                        next("/login");
                    }
                } else {
                    if(to.meta.supplier_portal) {
                        next({
                            path: `/supplier-portal/403-forbidden`,
                            query: { page: to.meta.title || to.meta.label }
                        });
                    } else {
                        const params = to.path.split("/").filter(x => x);
                        if(params.length) {
                            next({
                                path: `/${params[0]}/403-forbidden`,
                                query: { page: to.meta.title || to.meta.label }
                            });
                        }
                        next(false);
                    }
                    return
                }
                return;
            }
        } else {
            if (!store.getters['AuthController/isLoggedIn'] && to.path !== '/login') {
                if (LOGIN_REDIRECT_LINKS.includes(to.name)) {
                    next({ name: "GOfix FM-Commercial - Login", query: { from: to.fullPath } });
                } else {
                    next("/login");
                }
                return
            }
        }
        if(to.path == '/') {
            // if(localStorage.getItem('isNLTCso')) {
            //     next(`/case/list`);
            //     return;
            // } else {
                // if(router.app.$options.methods.$checkSupplier()){
                //     next(`/supplier-portal/dashboard`);
                //     return;
                // }
                next(`/v2/dashboard`);
                return;
            // }
        }
        next();
        if (goFix) {
            goFix.init({
                server: process.env.VUE_APP_SERVER_URL_AUTH + "/sso/login?checkForPlatForm=FM"
            });
            goFix.login_callback = (data) => {
                console.log('login_callback',data)
                localStorage.setItem("access_token", data.data.access_token);
                store.commit("AuthController/setAccessToken", data.data.access_token);
                global.axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.data.access_token;
                if (to.path === "/login") {
                    router.app.$store.dispatch("AuthController/getRoles").then(result => {
                        if (to.query.from) {
                            router.app.$store.dispatch("AuthController/getUser").then(result => {
                                if(result && result.data && result.data.data && result.data.data.microsoft2fa_enable){
                                    next({ path: "/two-factor-authentication", query: { from: to.query.from} });
                                    return;
                                }
                                next(to.query.from);
                            });
                        } else {
                            store.commit("AuthController/setIsFirstLogin", true);
                            router.app.$store.dispatch("AuthController/getUser").then(result => {
                                if(result && result.data && result.data.data && result.data.data.microsoft2fa_enable){
                                    next(`/two-factor-authentication`);
                                    return;
                                }
                                // if(result && result.data && result.data.data && result.data.data.roles) {
                                //     const arrTmp = result.data.data.roles.filter(item => item.name.toUpperCase() == 'NLT CSO')
                                //     if(arrTmp.length) {
                                //         localStorage.setItem("isNLTCso", 1);
                                //         next(`/case/list`);
                                //         return;
                                //     }
                                // }
                                // if(result && result.data && result.data.data && result.data.data.organization && result.data.data.organization.is_supplier){
                                //     next(`/supplier-portal/dashboard`);
                                //     return;
                                // }
                                next(`/v2/dashboard`);
                            });
                        }
                    });
                } else {
                    next();
                }
            };

            goFix.refresh_callback = (data) => {
                console.log('refresh_callback',data)
                localStorage.setItem("access_token", data.data.access_token);
                global.axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.data.access_token;
                if (data.refreshTime < -5000) {
                    location.reload();
                }
            };
            goFix.logout_callback = async(data) => {
                await localStorage.removeItem("access_token");
                await localStorage.clear();
                await router.app.$store.reset();
                if (to.path !== "/login") {
                    if (LOGIN_REDIRECT_LINKS.includes(to.name)) {
                        next({ name: "GOfix FM-Commercial - Login", query: { from: to.fullPath } });
                    } else {
                        next("/login");
                    }
                } else {
                    next();
                }
            };
            //
            if (to.path === '/two-factor-authentication') {
                if (token) {
                    if(router.app.$options.methods.$checkTwoFactorAuth()){
                        // if(router.app.$options.methods.$checkSupplier()){
                        //     next(`/supplier-portal/dashboard`);
                        //     return;
                        // }
                        next(`/v2/dashboard`);
                        return;
                    }
                    document.title = to.meta.title;
                    next();
                    return;
                }
            }

        } else {
            if (store.getters['AuthController/isLoggedIn']) {
                next()
            } else {
                if (LOGIN_REDIRECT_LINKS.includes(to.name)) {
                    next({ name: "GOfix FM-Commercial - Login", query: { from: to.fullPath } });
                } else {
                    next("/login");
                }
            }
        }
    } else {
        document.title = to.meta.title;
        next();
    }
});
export default router
